export interface TransMsg {
  en: String;
  zhHant: String;
  zhHans: String;
}

function build(...text): TransMsg {
  return {
    en: text[0],
    zhHant: text[1],
    zhHans: text[2],
  };
}

const messages = {
  general: {
    goBack: build("Go Back", "返回", "返回"),
    failedToLogin: build("Failed to Login", "登入失敗", "登入失敗"),
    restrictions: build("Restrictions", "限制", "限制"),
    setRetailShopRestrictions: build("Set Retail Shop Restrictions", "設置零售店限制", "設置零售店限制"),
    plsEnter: build("Please Enter", "請輸入", "请输入"),
    view: build("View", "檢視", "检视"),
    siteName: build("HER", "HER", "HER"),
    search: build("Search", "搜尋", "搜寻"),
    name: build("Name", "名稱", "名称"),
    url: build("URL", "網址", "網址"),
    enable: build("Enable", "啟用", "启用"),
    disable: build("Disable", "停用", "停用"),
    enabled: build("Enabled", "已啟用", "已启用"),
    disabled: build("Disabled", "已停用", "已停用"),
    yes: build("Yes", "是的", "是的"),
    no: build("No", "不", "不"),
    history: build("History", "歷史", "历史"),
    dataNotFound: build("Data Not Found", "找不到資料", "找不到资料"),
    select: build("Select", "選擇", "选择"),
    day: build("Day", "天", "天"),
    date: build("Date", "日期", "日期"),
    monday: build("Monday", "星期一", "星期一"),
    tuesday: build("Tuesday", "星期二", "星期二"),
    wednesday: build("Wednesday", "星期三", "星期三"),
    thursday: build("Thursday", "星期四", "星期四"),
    friday: build("Friday", "星期五", "星期五"),
    saturday: build("Saturday", "星期六", "星期六"),
    sunday: build("Sunday", "星期日", "星期日"),
    cantUpdateCoupon: build(
      "Can't Update Coupon At the moment. Please contact Admin",
      "目前無法更新優惠券，請聯繫管理員",
      "目前无法更新优惠券，请联系管理员"
    ),
    noRecordFound: build("No Record Found", "未找到記錄", "未找到记录"),
    code: build("Code", "代碼", "代码"),
    noneSelected: build("None Selected", "未選擇", "未选择"),
    selected: build("Selected", "已選擇", "已选择"),
  },
  index: {
    dashboard: build("Dashboard", "控制台", "仪表板"),
  },
  menu: {
    notAuthorized: build("You are not authorized to access this system", "您無權訪問此系統", "您无权访问此系统"),
    noAccess: build("No Access", "無權訪問", "无权访问"),
    login: build("Login", "登入", "登入"),
    logout: build("Logout", "登出", "登出"),
    changeLang: build("Change Language", "更改語言", "更改语言"),
    darkMode: build("Dark Mode", "黑暗模式", "黑暗模式"),
    lightMode: build("Light Mode", "日光模式", "日光模式"),
    colorTheme: build("Color Theme", "顏色主題", "颜色主题"),
  },
  material: {
    materialDetail: build("Material Detail", "物料內容", "物料内容"),
    add: build("Add Material", "新增物料", "新增物料"),
    edit: build("Edit Material", "更改物料", "更改物料"),
    materials: build("Materials", "物料", "物料"),
    materialName: build("Material Name", "物料名稱", "物料名称"),
    materialType: build("Material Type", "物料種類", "物料种类"),
    materialTypeName: build("Material Type Name", "物料種類名稱", "物料种类名称"),
    materialAttributes: build("Material Attributes", "物料屬性", "物料属性"),
    searchMaterial: build("Search Material", "搜尋物料", "搜寻物料"),
    create: build("Create", "新增物料", "新增物料"),
    editMaterial: build("Edit Material", "更改物料", "更改物料"),
    editMaterialType: build("Edit Material Type", "更改物料種頪", "更改物料种頪"),
  },
  productFile: {
    type: build("Type", "類型", "类型"),
    language: build("Language", "語言", "语言"),
    driver: build("Driver", "驅動器", "驱动器"),
    userManual: build("User Manual", "用戶手冊", "用户手册"),
    deleteTitle: build("Delete Product File", "刪除產品文件", "删除产品文件"),
    deleteConfirm: build(
      "Are You sure to delete this product file?",
      "你確定要刪除這個產品文件嗎？",
      "你确定要删除这个产品文件吗？"
    ),
  },
  product: {
    addCategories: build("Add Categories", "新增類別", "新增类别"),
    removeCategories: build("Remove Categories", "移除類別", "移除类别"),
    exclude: build("Exclude Product", "排除產品", "排除产品"),
    filterLocation: build("Filter Location", "篩選地區", "筛选地区"),
    filterProducts: build("Filter Products", "篩選產品", "筛选产品"),
    productFile: build("Product File", "產品文件", "产品文件"),
    productFileUpload: build("Product File Upload", "上傳產品文件", "上传产品文件"),
    productFileEdit: build("Edit Product File", "編輯產品文件", "编辑产品文件"),
    groupItem: build("Group Item", "群組項目", "群组项目"),
    generalInfo: build("General Info", "一般資料", "一般资料"),
    product: build("Product", "產品", "产品"),
    productName: build("Product Name"),
    serialNumber: build("Serial Number"),
    viewProduct: build("View Product"),
    warranty: build("Warranty", "保養", "保修"),
    productInfo: build("Product Info"),
    productListFilter: build("Product List Filter", "產品列表篩選", "产品列表筛选"),
    quantityChange: build("Quantity Change", "數量變更", "数量变更"),
    balance: build("Balance"),
    products: build("Products", "產品", "产品"),
    export: build("Export", "匯出", "导出"),
    add: build("Add Product", "新增產品", "新增产品"),
    addRecycle: build("Add Recycle Product", "添加回收產品", "添加回收产品"),
    attachRecycle: build("Attach Recycle Product", "連繫回收產品", "连繫回收产品"),
    name: build("Product Name", "產品名稱", "产品名称"),
    details: build("Product Details", "產品詳情", "产品详情"),
    description: build("Product Description", "產品說明", "产品说明"),
    shortDescription: build("Short Description", "簡短說明", "简短说明"),
    tag: build("Tag", "標籤", "标籤"),
    price: build("Product Price / Membership Price", "產品價格 / 會員價格", "产品价格 / 会员价格"),
    price2: build("Price", "價格", "价格"),
    recycleDeposit: build("Recycle Deposit", "回收按金", "回收押金"),
    recycleProduct: build("Recycle Inventory", "回收庫存", "回收库存"),
    eshopPrice: build("Eshop Price", "網店價格", "网店价格"),
    discountPrice: build("Discount Price", "折扣價格", "折扣价格"),
    default: build("Default", "預設", "默认"),
    defaultRetailPrice: build("Default POS Price", "預設 POS 價格", "默认 POS 价格"),
    retailPrices: build("POS Prices", "POS 價格", "POS 价格"),
    addRetailPrice: build("Add POS Price", "添加 POS 價格", "添加 POS 价格"),
    membershipPrices: build("Membership Prices", "會員價格", "会员价格"),
    edit: build("Edit Product", "更改產品", "更改产品"),
    editRecycle: build("Edit Recycle Product", "編輯回收產品", "编辑回收产品"),
    editChild: build("Edit Child Product", "更改子產品", "更改子产品"),
    batchEdit: build("Batch Edit", "批次編輯", "批次编辑"),
    productGallery: build("Product Gallery", "產品圖庫", "产品图库"),
    image: build("Image", "圖片", "图片"),
    featuredImage: build("Featured Image", "主要圖片", "主要图片"),
    descriptionGallery: build("Description Gallery", "描述圖庫", "描述图库"),
    sku: build("SKU", "SKU", "产品编号"),
    skuR: build("SKU Is Required", "SKU是必需的", "产品编号是必需的"),
    isPromotionProduct: build("Promotion Product", "推廣產品", "推廣产品"),
    simple: build("Simple Product", "簡易產品", "简易产品"),
    variationParent: build("Variation Product (Parent)", "多類產品 (母)", "多类产品 (母)"),
    variationChild: build("Variation (Child)", "子產品", "子产品"),
    inheritCategories: build("inherit categories from parent", "繼承父產品的類別", "继承父产品的类别"),
    custom: build("Custom", "客製化", "定制"),
    giftCard: build("Gift Card", "禮品卡", "礼品卡"),
    customOptions: build("Custom Options (Web)", "自訂選項（網路）", "自定义选项（网络）"),
    customSuggestions: build("Custom Suggestions (POS)", "自訂建議 (POS)", "自訂建议 (POS)"),
    topUps: build("Top Ups", "增值項目", "增值项目"),
    optionName: build("Option Name", "選項名稱", "选项名称"),
    createChildProduct: build("Create Variation Product (Child)", "更改多類 (子) 產品", "更改多类 (子) 產品"),
    editChildProduct: build("Edit Variation Product (Child)", "更改多類 (子) 產品", "更改多类 (子) 產品"),
    addAttributes: build("Add Attribute", "新增屬性", "添加属性"),
    addCustomOption: build("Add Option", "新增選項", "添加选项"),
    addChild: build("Add Child Product", "新增子產品", "新增子产品"),
    searchProduct: build("Search Product", "搜尋產品", "搜尋產品"),
    searchCustomer: build("Search Customer", "搜尋客戶", "搜寻客户"),
    relatedProducts: build("Related Products", "相關產品", "相關產品"),
    availability: build("Availability", "庫存狀況", "库存状况"),
    stockReadyDate: build("Stock Ready Date", "返貨日期", "返货日期"),
    expiaryDate: build("Expiary Date", "到期日期", "到期日期"),
    stock: build("Stock"),
    inStock: build("In Stock", "有貨", "有货"),
    outOfStock: build("Out of Stock", "缺貨", "缺货"),
    productType: build("Product Type", "產品類型", "產品類型"),
    bundleProducts: build("Bundle Products", "組合產品", "组合产品"),
    allowedVariations: build("Allowed Variations", "允許的子產品", "允许的子产品"),
    selectAllowedVariations: build("Select Allowed Variations", "選擇允許的變體", "选择允许的变体"),
    attachProduct: build("Attach Product", "附上產品", "附上产品"),
    attachProducts: build("Attach Products", "附加產品", "附加产品"),
    attachedProducts: build("Attached Products", "附屬產品", "附属产品"),
    alreadyAttached: build("Product is Already Attached", "產品已附加", "产品已附加"),
    suggestionType: build("Suggestion Type", "建議類型", "建议类型"),

    auto: build("Auto", "自動", "自动"),
    manual: build("Manual", "手動", "手动"),
    online: build("Online", "線上", "线上"),
    both: build("Both", "全部", "全部"),
    isOptional: build("Is Optional", "是可選的", "是可选的"),
    selectProduct: build("Select Product", "選擇產品", "选择产品"),
    quantity: build("Qty", "數量", "数量"),
    page: build("Page: ", "頁：", "頁："),
    go: build("Go", "前往", "前往"),
    itemsPerPage: build("Items per page: ", "每頁項目數：", "每页项目数："),
    misc: build("MISC", "其他", "其他"),

    productVisibility: build("Product Visibility", "產品知名度", "产品可见性"),
    productStatus: build("Product Status", "產品狀態", "产品状态"),
    disableProduct: build("Disable Product", "停用產品", "停用产品"),
    enableProduct: build("Enable Product", "啟用產品", "启用产品"),
    extUrl: build("External Url", "外部路徑", "外部路径"),
    brand: build("Brand", "品牌", "品牌"),
    addBrand: build("Add Brand", "添加品牌", "添加品牌"),
    shelf: build("Shelf", "倉位", "仓位"),
    discount: build("Discount", "折扣", "折扣"),
    overridePrice: build("Override price", "覆蓋單價", "覆盖单价"),
    active: build("Active", "生效", "生效"),
    inactive: build("Inactive", "停用", "停用"),
    draft: build("Draft", "草稿", "草稿"),
    private: build("Private", "不公開", "不公开"),
    deleted: build("Deleted", "已刪除", "已删除"),

    productHistory: build("Product History", "產品修改歷史", "产品修改历史"),
    totalProducts: build("Total Products", "總產品數", "总产品数"),

    preOrder: build("Pre Order", "預購", "预购"),
    isPreOrder: build("Is Pre Order", "是預訂", "是預訂"),
    preOrderLimit: build("Pre Order Limit", "預訂限額", "预订限额"),
    preOrderRemarks: build("Pre Order Remarks", "預訂備註", "预订备注"),
    estArrivalDate: build("Estimated Arrival Date", "預計抵達日期", "预计抵达日期"),
    boxConversion: build("Box Conversion", "箱轉換", "箱转换"),
    boxConversionName: build("Box Name", "箱名稱", "箱名称"),
    conversionRate: build("Conversion Rate", "轉換率", "转换率"),
    addBoxConversion: build("Add Box Conversion", "添加箱轉換", "添加箱转换"),
    removeBoxConversion: build("Remove", "移除", "移除"),
    cost: build("Cost", "成本", "成本"),
    barcode: build("Barcode", "條碼", "条形码"),
    status: build("Status", "狀態", "状态"),
    pleaseWait: build("Please wait, uploading file", "請稍候，正在上傳文件", "请稍候，正在上传文件"),
    uploadNew: build("Upload new image from this computer", "從這台電腦上傳新圖像", "从这台计算机上传新图像"),
    chooseRecent: build("Choose from media", "從圖片庫選擇", "从图片库选择"),
    addLink: build("Add Link", "新增連結", "添加链接"),
  },
  category: {
    category: build("Category", "類別", "类别"),
    code: build("Code", "代碼", "代码"),
    add: build("Add Category", "新增類別", "新增类别"),
    exclude: build("Exclude Category", "排除類別", "排除类别"),
    name: build("Category Name", "類別名稱", "类别名称"),
    description: build("Category Description", "類別描述", "类别描述"),
    slug: build("Slug", "路徑標籤", "路径标签"),
    parent: build("Parent Category", "上層類別", "上层类别"),
    rewardPayout: build("Reward Payout", "積分派率", "積分派率"),
    rewardPayoutInfo: build(
      "Setting Reward Payout to 0 will exclude all products in this category from earning reward points, even if the shop-level reward payout is enabled. If a product belongs to multiple categories and any category has rewardPayout set to 0, the product will not earn points.",
      "將積分派率設為0後，此類別中的所有產品將不會獲得積分。如果產品擁有多個類別，只要任何一個類別的積分派率設為0，該產品將不會獲得積分。",
      "将积分派率设为0后，此类别中的所有产品将不会获得积分。如果产品拥有多个类别，只要任何一个类别的积分派率设为0，该产品将不会获得积分。"
    ),
    rewardPayoutInfoTitle: build("Reward Payout Information", "積分派率資訊", "积分派率信息"),
    editCategory: build("Edit Category", "修改類別", "修改类别"),
    addParent: build("Add Parent Category", "新增上層類別", "新增上层类别"),
    delete: build("Delete Category", "刪除類別", "删除类别"),
    selectCategories: build("Select Categories", "選擇類別", "选择类别"),
    addCategories: build("Add Categories", "新增類別", "新增类别"),
    removeCategories: build("Remove Categories", "移除類別", "移除类别"),
    search: build("Search Categories ...", "搜尋類別 ...", "搜尋類別 ..."),
    icon: build("Icon", "圖示", "图示"),
    isPromotion: build("Promotion", "推廣類別", "推广类别"),
  },
  tag: {
    name: build("Tag Name", "標籤名稱", "标签名称"),
    tag: build("Tag", "標籤", "标签"),
    slug: build("Slug", "路徑標籤", "路径标签"),
    enable: build("Enable", "啟用", "启用"),
    add: build("Add Tag", "添加标签", "编辑标签"),
    edit: build("Edit Tag", "新增標籤", "編輯標籤"),
    selectTags: build("Select Tags", "選擇標籤", "选择标签"),
    searchTags: build("Search Tags ...", "搜尋標籤 ...", "搜尋標籤 ..."),
  },
  adhocItem: {
    adhoc: build("Adhoc", "特別指定", "特别指定"),
    adhocTotal: build("Adhoc Total", "臨時總計", "临时总计"),
    description: build("Adoc Descrption", "ADOC描述", "ADOC描述"),
    price: build("Price", "價格", "价格"),
    quantity: build("Qty", "數量", "数量"),
    total: build("Total", "總金額", "总金额"),
    edit: build("Edit", "编辑文档", "編輯文檔"),
  },
  attribute: {
    attribute: build("Attribute", "屬性", "屬性"),
    attributes: build("Attributes", "屬性", "屬性"),
    add: build("Add Attribute", "新增屬性", "新增屬性"),
    edit: build("Edit Attribute", "更改屬性", "更改屬性"),
    name: build("Attribute Name", "屬性名稱", "屬性名稱"),
    type: build("Attribute Type", "屬性類形", "屬性類形"),
    unit: build("Attribute Unit", "屬性單位", "屬性單位"),
    text: build("Text", "文字", "文字"),
    number: build("Number", "數值", "數值"),
    display: build("Display", "顯示", "顯示"),
    typeAll: build("All", "全部", "全部"),
    typeNone: build("None", "不顯示", "不显示"),
    selectAttr: build("Select Attributes", "選擇屬性", "选择属性"),
  },
  scanner: {
    barcode: build("Bar Code", "條碼", "条形码"),
    qrCode: build("QR Code", "二維碼", "二维码"),
    enterValue: build("Enter Value:", "輸入值：", "输入值："),
    or: build("OR", "或者", "或者"),
    scanBarcode: build("scan barcode", "掃描條碼", "扫描条形码"),
  },
  brand: {
    brand: build("Brand", "品牌", "品牌"),
    brands: build("Brands", "品牌", "品牌"),
    add: build("Add Brand", "添加品牌", "添加品牌"),
    edit: build("Edit Brand", "編輯品牌", "編輯品牌"),
    name: build("Brand Name", "品牌", "品牌"),
    selectBrands: build("Select Brands", "選擇品牌", "选择品牌"),
    exclude: build("Exclude Brand", "排除品牌", "排除品牌"),
    showInventory: build("Show Inventory", "顯示庫存", "显示库存"),
  },
  shelf: {
    shelf: build("Shelf", "倉位", "仓位"),
    shelves: build("Shelves", "倉位", "仓位"),
    add: build("Add Shelf", "添加倉位", "添加仓位"),
    edit: build("Edit Shelf", "編輯倉位", "编辑仓位"),
    name: build("Shelf Name", "倉位", "仓位"),
    delete: build("Delete Shelf", "刪除倉位", "删除仓位"),
  },
  socials: {
    whatsapp: build("Whatsapp", "", ""),
    website: build("Website", "", ""),
  },
  inventory: {
    inventory: build("Inventory", "倉存", "仓存"),
    orderStock: build("Order Stock"),
    poNumber: build("PO Number"),
    outlet: build("Outlet"),
    adjustmentReason: build("Adjustment reason"),
    adjustmentQuatity: build("Adjustment quantity"),
    allOutlets: build("All Outlets"),
    psnSi: build("Product order Number / Supplier Invoice"),
    inventoryManagement: build("Inventory Management"),
    adft: build(
      "Adding details for this order helps you stay on top of all your orders and means your staff can easily identify incoming items"
    ),
    twto: build("Track when the order is due so you can see what's in transit."),
    tnad: build(
      " This number and delivery date will be visible to your cashiers and managers to help them identify inbound inventory."
    ),
    cpta: build("Choose products to add to this order, or upload a CSV file of products to import."),
    chooseProducts: build("Choose products"),
    ivc: build("Import via CSV"),
    importCsv: build("Import CSV"),
    optional: build("Optional"),
    mustBeUnique: build("Must be a unique number"),
    noFileChosen: build("No files chosen"),
    logs: build("Logs", "記錄", "记录"),
    category: build("Category"),
    supplier: build("Supplier", "供應商", "供应商"),
    addSupplier: build("Add Supplier", "新增供應商", "添加供应商"),
    addWarehouse: build("Add Warehouse", "新增倉庫", "添加仓库"),
    createWarehouse: build("Create Warehouse", "建立倉庫", "创建仓库"),
    editWarehouse: build("Edit Warehouse", "編輯倉庫", "编辑仓库"),
    ordered: build("Ordered"),
    supplierCode: build("Supplier Code"),
    purchaseOrder: build("Purchase Order", "採購單", "採购单"),
    stockControl: build("Stock Control"),
    brand: build("Brand"),
    productName: build("Product Name"),
    editInventory: build("Edit Inventory"),
    preprocessAllProducts: build("Recalcualte Inventory", "重新計算倉存", "重新计算仓存"),
    newPurchaseOrder: build("New Purchase Order"),
    receiveStock: build("Receive Stock"),
    transferStock: build("Transfer Stock"),
    returnStock: build("Return Stock"),
    created: build("Created"),
    deliverTo: build("Deliver To"),
    supplyCostPer: build("Supply Cost/per"),
    totalSupplyCost: build("Total Supply Cost"),
    createdBy: build("Created By"),
    createdDue: build("Created due"),
    editOrder: build("Edit Order"),
    costPriceHKD: build("Cost Price (HKD)"),
    totalPriceHKD: build("Total Cost (HKD)"),
    conversionRate: build("Conversion Rate", "轉換率", "转换率"),
    recieve: build("Recieve"),
    searchProduct: build("Search Product", "搜尋產品", "搜尋產品"),
    startStopDateTime: build("Start Date/Time"),
    dateTime: build("Date/Time", "日期/時間", "日期/时间"),
    userEmployee: build("User/Employee"),
    action: build("Action", "動作", "动作"),
    search: build("Search", "搜尋", "搜尋"),
    exportCSV: build("Export CSV", "匯出CSV", "汇出CSV"),
    tag: build("Tag", "標籤", "标籤"),
    addInvntory: build("Add inventory", "新增倉存", "新增仓存"),
    selectWarehouse: build("Select a warehouse", "選擇貨倉", "选择货仓"),
    selectBrand: build("Select a brand", "選擇品牌", "选择品牌"),
    allStatus: build("All status", "所有狀態", "所有状态"),
    arrivalDate: build("Arrival Date", "到貨日期", "到货日期"),
    selectSupplier: build("Select a supplier", "選擇供應商", "选择供应商"),
    saveQuote: build("Add products to this purchase order to keep track of inbound inventory."),
    text: build("Text", "文字", "文字"),
    number: build("Number", "數值", "數值"),
    invDescript1: build(
      "The type of product we choose determines how we manage inventory and reporting.",
      "根據不同的產品類型來決定我們如何管理倉存及產生報表",
      "根据不同的产品类型来决定我们如何管理仓存及产生报表"
    ),
    invDescript2: build(
      "Add products to this purchase order to keep track of inbound inventory.",
      "將產品加入到採購單來管理入倉程序",
      "将产品加入到採购单来管理入仓程序"
    ),
    instock: build("In Stock", "有貨", "有货"),
    notEnoughStock: build("Not Enough Stock", "庫存不足", "库存不足"),
    quantityLess: build(
      "quantity greater than avalaible inventory, please adjust",
      "數量大於可用庫存，請調整",
      "数量大于可用库存，请调整"
    ),
    parentInventoryNotice: build("Variation Product", "多類產品", "多类产品"),
    bundleInventoryNotice: build("Bundle Product", "組合產品", "组合产品"),
    boxConversionInventoryNotice: build("Box Conversion Set", "箱轉換", "箱转换"),
  },

  merchant: {
    merchants: build("Merchants", "分銷商", "分銷商"),
    create: build("Create New Merchant", "新增分銷商", "新增分銷商"),
    addUser: build("Add Merchant User", "新增分銷商用戶", "新增分銷商用戶"),
    typeAdmin: build("Admin", "管理員", "管理員"),
    typeShopManager: build("Shop Manager", "商店管理員", "商店管理員"),
  },
  customer: {
    searchCustomer: build("Search Customer", "搜尋客戶", "搜尋客戶"),
    updatePassword: build("Update Password", "更新密碼", "更新密碼"),
    updateCustomerPassword: build("Update Customer Password", "更新客戶密碼", "更新客戶密碼"),
    customer: build("Customer", "客戶", "客戶"),
    customers: build("Customers", "客戶", "客戶"),
    name: build("Name", "名字", "名字"),
    mobile: build("Mobile Number", "電話號碼", "电话号码"),
    provider: build("Provider", "來源", "来源"),
    notVerified: build("Not Verified", "未驗證", "已验证"),
    verified: build("Verified", "已驗證", "已驗證"),
    firstName: build("First Name", "名字", "名字"),
    lastName: build("Last Name", "姓", "姓"),
    firstNameL: build("First Name:", "名字：", "名字："),
    lastNameL: build("Last Name:", "姓：", "姓："),
    emailL: build("Email Address:", "電郵地址：", "電郵地址："),
    sendLink: build("Send To Customer", "發送給客戶", "发送给客户"),
    summary: build("Summary", "摘要", "摘要"),
    rewardPointsL: build("Reward Points:", "獎勵積分：", "獎勵積分："),
    recentOrders: build("Recent Orders", "最近訂單", "最近訂單"),
    recentRewards: build("Recent Rewards", "最近獎勵", "最近獎勵"),
    viewAllOrders: build("View All Customer Orders", "查看所有客戶訂單", "查看所有客户订单"),
    viewAllRewards: build("View All Customer Rewards", "查看所有客戶獎勵", "查看所有客户奖励"),
    addCustomer: build("Add Customer", "新增客戶", "新增客户"),
    suspend: build("Suspend Customer", "暫停客戶", "暂停客户"),
    unsuspend: build("Unsuspend Customer", "恢復客戶", "恢复客户"),
    suspended: build("Suspended", "已暫停", "已暂停"),
    blacklist: build("Blacklist Customer", "加入黑名單", "加入黑名单"),
    unblacklist: build("Unblacklist Customer", "移除黑名單", "移除黑名单"),
    blacklisted: build("Blacklisted", "已加入黑名單", "已加入黑名单"),
    emailVerified: build("Email Verified", "電郵已驗證", "电邮已验证"),
    mobileNumberVerified: build("Mobile Number Verified", "電話號碼已驗證", "电话号码已验证"),
    verify: build("Verify", "驗證", "验证"),
    unverify: build("Unverify", "取消驗證", "取消验证"),
    emailExists: build("Email already exists", "電郵已被使用", "电邮已被使用"),
    telExists: build("Mobile number already exists", "電話號碼已被使用", "电话号码已被使用"),
  },
  banner: {
    banner: build("Banner", "橫幅", "橫幅"),
    add: build("Add Banner", "新增橫幅", "新增橫幅"),
    edit: build("Edit Banner", "更改橫幅", "更改橫幅"),
    delete: build("Delete Banner", "刪除橫幅", "刪除橫幅"),
    uploadBanner: build("Upload Banner", "上傳橫幅", "上傳橫幅"),
    selectBannerType: build("Select Banner Type", "選擇橫幅類型", "選擇橫幅類型"),
    topBarBanners: build("Top Bar", "置頂橫幅", "置顶横幅"),
    headerBanners: build("Header", "標題橫幅", "標題橫幅"),
    footerBanners: build("Footer", "標腳橫幅", "標腳橫幅"),
    sidebarBanners: build("Sidebar", "側邊欄", "侧边栏"),
    carouselBanners: build("Carousel", "輪播", "旋转木马"),
    sectionBanners: build("Section", "部分", "部分"),
    html: build("Banner HTML (Optional)", "橫幅 HTML (可選)", "横幅 HTML (可选）"),
    dragInstruction: build(
      "Drag and drop the item to the new position to reorder the banner items.",
      "如要更新橫幅排序，請將橫幅行拖移到相應新位置。",
      "如要更新横幅排序，请将横幅行拖移到相应新位置。"
    ),
  },
  menuItem: {
    title: build("Menu Items", "選單", "选单"),
    help: build(
      "Configure navigation items shown on the storefront (category or custom link).",
      "設定店面導覽列顯示的項目（分類或自訂連結）。",
      "设定店面导航列显示的项目（分类或自定义链接）。"
    ),
    create: build("Add menu item", "新增選單項目", "新增选单项目"),
    edit: build("Edit menu item", "編輯選單項目", "编辑选单项目"),
    delete: build("Delete menu item", "刪除選單項目", "删除选单项目"),
    order: build("Order", "排序", "排序"),
    type: build("Type", "類型", "类型"),
    typeCategory: build("Category", "分類", "分类"),
    typeLink: build("Link", "連結", "连结"),
    selectCategory: build("Select a category", "選擇分類", "选择分类"),
    linkLabel: build("Label", "標籤", "标签"),
    linkHref: build("URL or path", "網址或路徑", "网址或路径"),
    target: build("Target", "目標", "目标"),
    empty: build("No menu items yet.", "尚無選單項目。", "尚无选单项目。"),
    dragInstruction: build(
      "Drag a row to a new position to change the order.",
      "拖曳列到新位置即可變更排序。",
      "拖曳列到新位置即可变更排序。"
    ),
    deleteConfirmTitle: build("Delete menu item", "刪除選單項目", "删除选单项目"),
    deleteConfirmMessage: build(
      "Are you sure you want to delete this menu item?",
      "確定要刪除此選單項目嗎？",
      "确定要删除此选单项目吗？"
    ),
  },
  media: {
    media: build("Media", "媒體庫", "媒体库"),
    mediaInfo: build("Media Info", "媒體資料", "媒体资料"),
    add: build("Upload Media File", "上傳媒體", "上传媒體"),
    addS: build("Add Media Files", "新增媒體", "新增媒體"),
    addG: build("Select from Media Library", "在媒體庫中選擇", "在媒体库中选择"),
    addN: build("Add New Media", "新增媒體檔", "新增媒体档"),
    size: build("Size", "尺寸", "尺寸"),
    uploadMediaFile: build("Upload Media File", "上載媒體", "上载媒体"),
    mediaLinks: build("Media URLs", "媒體連結", "媒体连结"),
    original: build("Original", "原圖", "原图"),
    thumbnail: build("Thumbnail", "壓縮圖", "压缩图"),
    confirmDelete: build("Confirm to Delete", "確認刪除", "确认删除"),
    deleteWarning: build(
      "Deleting media will unlink it from associated products. This action cannot be undone.",
      "刪除媒體將從相關產品中解除連結。此操作無法撤消。",
      "删除媒体将从相关产品中解除连接。此操作无法撤消。"
    ),
    addSelected: build("Add Selected", "新增選定項", "添加选定项"),
  },
  setting: {
    collapse: build("Collapse menu", "折疊菜單", "折叠菜单"),
    setting: build("Profile Setting", "個人設定", "個人設定"),
    chooseLanguage: build("Choose Language", "選擇語言", "選擇語言"),
    chooseShop: build("Choose Shop", "選擇商店", "選擇商店"),
    languages: build("Languages", "語言", "語言"),
    english: build("English", "英文", "英文"),
    chineseT: build("Traditional Chinese", "繁體中文", "繁体中文"),
    chineseS: build("Simplified Chinese", "簡體中文", "简体中文"),
    userRole: build("User Role", "用戶角色", "用戶角色"),
    email: build("Email Address", "電郵地址", "电邮地址"),
    password: build("Password", "密碼", "密码"),
    forgetPassword: build("Forget Password", "忘記密碼", "忘记密码"),
    defaultLocale: build("Default Language", "默認語言", "默認語言"),
    currencies: build("Currencies", "貨幣", "貨幣"),
    defaultCurrency: build("Default Currency", "點認貨幣", "點認貨幣"),
    hkd: build("HKD", "港幣", "港幣"),
    cny: build("CNY", "人民幣", "人民幣"),
    usd: build("USD", "美金", "美金"),
    enableMobileRedirect: build("Mobile Redirect"),
    showHerLogo: build("Show HER Logo", "顯示 HER Logo", "显示 HER Logo"),
    showClientLogo: build("Show Client Logo", "顯示客戶 Logo", "显示客户 Logo"),
  },
  locale: {
    en: build("EN", "英"),
    tc: build("TC", "繁", "繁"),
    sc: build("SC", "簡", "简"),
  },
  user: {
    loginHere: build("Login Here", "按此登入", "按此登入"),
    yourAccountIsVerifiedSuccessfully: build(
      "Your account is verified successfully.",
      "您的帳戶已成功驗證。",
      "您的账户已成功验证。"
    ),
    firstname: build("First Name", "名字", "名字"),
    lastname: build("Last Name", "姓", "姓"),
    email: build("Email", "電郵", "電郵"),
    mobileNumber: build("Mobile Number", "手機", "手機"),
    addNewCustomer: build("Add New Customer", "新增客戶", "新增客户"),
    user: build("User", "用戶", "用戶"),
    userEmployee: build("User/Employee/Order"),
    users: build("Users", "用戶", "用戶"),
    addUser: build("Add User", "新增用戶", "新增用戶"),
    editUser: build("Edit User", "更改用戶", "更改用户"),
    editRetailShop: build("Edit Retail Shop", "更改零售商店", "更改零售商店"),
    manageRetailUser: build("Manage Retail User", "管理零售用戶", "管理零售用户"),
    editRetailUser: build("Edit Retail User", "更改零售用戶", "更改零售用户"),
    addRetailUser: build("Add Retail User", "新增零售用戶", "新增零售用户"),
    resend: build("Resend", "重新發送", "重新發送"),
    resendStatusFailed: build("Failed", "發送失敗", "發送失敗"),
    resendStatusSending: build("Sending...", "發送中", "發送中"),
    resendStatusSent: build("Sent", "發送成功", "發送成功"),
    removeUser: build("Remove User", "移除用戶", "移除用户"),
    removeUserConfirmation: build("Remove User Confirmation", "確認移除用戶", "确认移除用户"),
    removeUserClickToConfirm: build("Please confirm to remove user", "請確認是否要移除用戶", "请确认是否要移除用户"),
    confirm: build("Confirm", "確認", "确认"),
    changePwd: build("Change Password", "更改密碼", "更改密码"),

    disableOfficeHours: build("Disable Office Hours", "停用營業時間", "停用營業時間"),
    disableRestriction: build("Disable Restriction", "停用限制", "停用限制"),
    listOfAllowedIPs: build("List of Allowed IPs", "允許的IP列表", "允許的IP列表"),
    getCurrentIP: build("Get Current IP", "獲取當前IP", "獲取當前IP"),
    enterIP: build("Enter IP", "輸入IP", "輸入IP"),
    daysOfWeeks: build("Days of Week", "星期", "星期"),
    timeRestrictions: build("Time Restrictions", "時間限制", "时间限制"),
    startTime: build("Start Time", "開始時間", "开始时间"),
    endTime: build("End Time", "結束時間", "结束时间"),
    addAnother: build("Add Another", "新增另一個", "新增另一个"),
    mon: build("Mon", "週一", "周一"),
    tue: build("Tue", "週二", "周二"),
    wed: build("Wed", "週三", "周三"),
    thu: build("Thu", "週四", "周四"),
    fri: build("Fri", "週五", "周五"),
    sat: build("Sat", "週六", "周六"),
    sun: build("Sun", "週日", "周日"),
    currentPwd: build("Current Password", "現在的密碼", "现在的密码"),
    newPwd: build("New Password", "新密碼", "新密码"),
    pwdStrengthNotice: build(
      "A password should contain captial case, small case, number, and special character with min length 8",
      "密碼必須包括英文大寫，英文小寫，數字，及特別符號。長度8位或以上。",
      "密码必须包括英文大写，英文小写，数字，及特别符号。长度8位或以上。"
    ),
    createYourPassword: build("Create Your Password", "建立密碼", "建立密码"),
    generatePassword: build("Generate", "生成", "生成"),
    updatePassword: build("Update Password", "更新密碼", "更新密码"),
    updatePasswordClickToConfirm: build(
      "Please confirm to update user password",
      "請確認是否要更新用戶密碼",
      "请确认是否要更新用户密码"
    ),
    status: build("Status", "狀態", "状态"),
    role: build("Role", "角色", "角色"),
    statusCreated: build("Created", "已建立", "已建立"),
    statusPending: build("Pending", "待確認", "待确认"),
    typeAdmin: build("Admin", "管理員", "管理员"),
    typeShopManager: build("Shop Manager", "商店經理", "商店经理"),
    typeRetail: build("Retail User", "零售用戶", "零售用户"),
    setOffHours: build("Set Off Hours", "設定休息時間", "设定休息时间"),
    emailVerification: build("Email Verification", "電郵驗證", "電郵驗證"),
    alreadyVerified: build("Already Verified", "已驗證", "已验证"),
    failedOrNotExists: build("Failed Or Not Exists", "驗證失敗或不存在", "验证失败或不存在"),
  },

  specialist: {
    specialist: build("Specialist", "專家", "专家"),
    specialists: build("Specialists", "專家", "专家"),
    add: build("Add Specialist", "新增專家", "添加专家"),
    edit: build("Edit Specialist", "編輯專家", "編輯專家"),
    name: build("Specialist Name", "专科医生姓名", "專家姓名"),
    optometrist: build("Optometrist", "驗光師", "验光师"),
    tailor: build("Tailor", "裁缝", "裁縫"),
    driver: build("Driver", "司機", "司机"),
  },

  shop: {
    setting: build("Shop Setting", "商店設定", "商店設定"),
    inventoryStatus: build("Inventory Status"),
    eshopInventoryEnabled: build("eShop Inventory Enabled"),
    retailInventoryEnabled: build("Retails Inventory Enabled"),
    recycleEnabled: build("Enable Product Recycling", "實現產品回收", "实现产品回收"),
    posOnlineOrderEnabled: build("Enable POS Online Order", "啟用 POS 線上訂購", "启用 POS 网上订购"),
    combineOrderEnabled: build("Enable Combine Order", "啟用合併訂單", "启用合并订单"),
    posDeliveryMenuEnabled: build("Enable POS Delivery Menu", "啟用 POS 配送選單", "启用 POS 配送选单"),
    preventShipSettingMismatch: build("Prevent Ship Setting Mismatch", "防止船舶設定不匹配", "防止船舶设置不匹配"),
    giftCardAutoConversionEnabled: build("Convert Gift Card To Reward", "將禮品卡轉換為獎勵", "将礼品卡转换为奖励"),
    selectEshopWarehouse: build("Select Eshop Warehouse", "選擇網店倉庫", "选择网店仓库"),
    shippingSetting: build("Shipping Setting", "運送設定", "運送設定"),
    paySetting: build("Payment Setting", "付款設定", "付款設定"),
    addPaySetting: build("Add Payment Setting", "新增付款設定", "新增付款設定"),
    editPaySetting: build("Edit Payment Setting", "更新付款設定", "更新付款設定"),
    addNewShipSetting: build("Add Ship Setting", "新增運送設定", "新增運送設定"),
    editShipSetting: build("Update Ship Setting", "更新運送設定", "更新運送設定"),
    name: build("Shop Name", "商店名稱", "商店名稱"),
    rootUrl: build("Root URL", "根網址", "根網址"),
    emailFrom: build("Email From", "電郵 From", "電郵 From"),
    smtp: build("SMTP", "SMTP", "SMTP"),
    logo: build("Logo", "Logo", "Logo"),
    googleClientId: build("Google Client ID", "Google Client ID", "Google Client ID"),
    googleSecret: build("Google Secret", "Google Secret", "Google Secret"),
    createShop: build("Create Shop", "建立商店", "建立商店"),
    shopTypeRegular: build("Regular Shop", "一般商店", "一般商店"),
    shopTypeMultiMerchant: build("Multi Merchant Shop", "多戶式商店", "多戶式商店"),
    shopType: build("Shop Type", "商店類型", "商店類型"),
    timeZone: build("Time Zone", "時區", "时区"),
    accessYouUser: build("AccessYou User ID", "AccessYou 用戶號碼", "AccessYou 用戶號碼"),
    accessYouAcctNo: build("AccessYou Account No", "Access You 賬戶號碼", "Access You 賬戶號碼"),
    accessYouPw: build("AccessYou Password", "AccessYou 密碼", "AccessYou 密碼"),
    otpMsg: build("OTP Message", "OTP 信息", "OTP 信息"),
    rewardPayout: build("Reward Payout", "積分派率", "積分派率"),
    rewardEarnedDeductions: build("Deduct From Earned Reward", "從獲得的獎勵中扣除", "从获得的奖励中扣除"),
    rewardAppliesTo: build("Reward Applies To", "獎勵適用於", "奖励适用于"),
    couponAppliesTo: build("Coupon Applies To", "優惠券適用於", "优惠券适用于"),
    giftCardAppliesTo: build("Gift Card Applies To", "禮品卡適用對象", "礼品卡适用对象"),
    membershipAppliesTo: build("Membership Applies To", "會員資格適用於", "会员资格适用于"),
    membershipDiscountBase: build("Membership Discount Base", "會員折扣基準", "会员折扣基准"),
    membershipDiscountBaseOriginalPrice: build("Original Price", "原價", "原价"),
    membershipDiscountBaseDiscountPrice: build("Discount Price", "折後價", "折后价"),
    membershipDiscountBaseMembershipPrice: build("Membership Price", "會員價", "会员价"),
    cartItemPrice: build("Cart Original Price Basis", "購物車原價依據", "购物车原价依据"),
    cartItemPriceBasePrice: build("Base price", "基本價格", "基本价格"),
    cartItemPriceEshopPrice: build("E-shop listed price", "網店上架價", "网店上架价"),
    minOrderAmtAfterDeduct: build("Min. Order Amt After Deduct", "最低訂單金額（扣除後）", "最低订单金额（扣除后）"),
    order: build("Order", "訂單", "订单"),
    autoSelectGuest: build("Auto Select Guest Customer", "自動選擇訪客客戶", "自动选择来宾客户"),
    tax: build("Tax", "稅", "税"),
    code: build("Shop Code", "商店代碼", "商店代码"),
    shopId: build("Shop ID", "商店ID", "商店ID"),
    supplier: build("Supplier"),
    createSupplier: build("Create Supplier"),
    addSupplier: build("Add Supplier"),
    editSupplier: build("Edit Supplier"),
    emailAndMessages: build("Email And Messages", "電子郵件和訊息", "电子邮件和信息"),
    locales: build("Locales", "區域設置", "区域设置"),
    authentication: build("Auth Keys", "授權密鑰", "验证密钥"),
    paypalKeys: build("Paypal Keys", "Paypal 金鑰", "Paypal 金钥"),
    stripeKeys: build("Stripe Keys", "Stripe 金鑰", "Stripe 金钥"),
    orderManagement: build("Order Management", "訂單管理", "訂單管理"),
    userManagement: build("User Management", "使用者管理", "用户管理"),
    orderAutoCancel: build("Auto Cancel Order", "自動取消訂單", "自动取消订单"),
    hours: build("Hours", "時間", "小时"),
    rewardExpires: build("Reward Expires After How Many Days", "獎勵在多少天後過期", "奖励在多少天后过期"),
    cost: build("Cost", "成本", "成本"),
    preOrderEstArrival: build("PreOrderEstimate", "預訂估價", "预订估价"),
    roundUp0: build("Round Up (0 Decimal)", "Round Up (0小數位)", "Round Up (0小数位)"),
    roundDown0: build("Round Down (0 Decimal)", "Round Down (0小數位)", "Round Down (0小数位)"),
    roundHalf0: build("Round Half (0 Decimal)", "四捨五入 (0小數位)", "四舍五入 (0小数位)"),
    roundUp1: build("Round Up (1 Decimal)", "Round Up (1位小數)", "Round Up (1位小数)"),
    roundDown1: build("Round Down (1 Decimal)", "Round Down (1位小數)", "Round Down (1位小数)"),
    roundHalf1: build("Round Half (1 Decimal)", "四捨五入 (1位小數)", "四舍五入 (1位小数)"),
    roundUp2: build("Round Up (2 Decimals)", "Round Up (2位小數)", "Round Up (2位小数)"),
    roundDown2: build("Round Down (2 Decimals)", "Round Down (2位小數)", "Round Down (2位小数)"),
    roundHalf2: build("Round Half (2 Decimal)", "四捨五入 (2位小數)", "四舍五入 (2位小数)"),
    roundOffOrderReward: build("Round Off Order Reward", "進位 - 積分", "進位 - 積分"),
    roundOffOrderTotal: build("Round Off Online Order", "進位 - 網店訂單", "進位 - 網店訂單"),
    roundOffPosOrder: build("Round Off POS Order", "進位 - POS 訂單", "進位 - POS 訂單"),
    checoutSessionStaleTime: build(
      "Checkout Time or Stock Hold Time(in Minutes)",
      "結帳時間或庫存保留時間（分鐘",
      "结账时间或库存保留时间（分钟)"
    ),
    rounding: build("Rounding", "進位", "进位"),
    eshopOrderCancelTime: build("eShop Order Cancel Time (hours)", "網店訂單取消時間（小時）", "网店订单取消时间（小时）"),
    defaultRetailOrderCancelTime: build(
      "Default Retail Order Cancel Time (hours)",
      "默認零售訂單取消時間（小時）",
      "默认零售订单取消时间（小时）"
    ),
    retailCancelTimes: build("Retail Cancel Times", "零售訂單取消時間", "零售订单取消时间"),
    orderCreatedEmailDelayMinutes: build(
      "Order Created Email Delay (minutes, 0=disabled)",
      "訂單建立提醒郵件延遲（分鐘，0=停用）",
      "订单建立提醒邮件延迟（分钟，0=停用）"
    ),
  },
  ship: {
    productRestriction: build("Product Restriction", "產品限制", "产品限制"),
    categoryRestriction: build("Category Restriction", "類別限制", "类别限制"),
    shipOptionRestriction: build("Ship Option Restriction", "運送選項限制", "运送选项限制"),
    selectShipOption: build("Select Ship Option", "選擇運送選項", "选择运送选项"),
    placementRestriction: build("Placement Restriction", "投放位置限制", "投放位置限制"),
    none: build("None", "沒有應用", "没有应用"),
    inclusion: build("Inclusion", "包含", "包含"),
    exclusion: build("Exclusion", "排除", "排除"),
    shipping: build("Shipping", "運送", "運送"),
    shipSettingOption: build("Ship Setting Option", "運送選項", "運送選項"),
    optionName: build("Option Name", "選項名稱", "選項名稱"),
    shipType: build("Ship Type", "運送方式", "運送方式"),
    setting: build("Setting", "設定", "設定"),
    name: build("Name", "名稱", "名稱"),
    type: build("Type", "類別", "類別"),
    option: build("Option", "設定", "設定"),
    edit: build("Edit", "更改", "更改"),
    removeShipSettingConfirmation: build("Remove Shipping Setting Confirmation", "移除運送設定確認", "移除运送设定确认"),
    feeTypeFree: build("Free Shipping", "免費", "免費"),
    feeTypeFlat: build("Flat Shipping", "劃一費用", "劃一費用"),
    shipTypeSf: build("S.F. Express", "順豐速運", "順豐速運"),
    shipTypeBasic: build("Regular Shipping", "一般運送", "一般運送"),
    shipTypePickup: build("Store Pickup", "門市自取", "門市自取"),
    addOption: build("Add Option", "新增運送選項", "新增運送選項"),
    shipOption: build("Ship Option", "運送選項", "運送選項"),
    addFeeOption: build("Add Fee Option", "新增運費選項", "新增運費選項"),
    feeOption: build("Fee Option", "運費選項", "運費選項"),
    remove: build("Remove", "移除", "移除"),
    feeType: build("Fee Type", "運費類別", "運費類別"),
    freeShippingSetting: build("Free Shipping Setting", "免運費設定", "免運費設定"),
    freeAboveAmt: build("Free Above Amount", "超出此金額後免費", "超出此金額後免費"),
    flatShippingSetting: build("Flat Shipping Setting", "劃一運費設定", "劃一運費設定"),
    flatRate: build("Flat Rate", "劃一運費", "劃一運費"),
    aboveAmt: build("Above Amount", "此金額以上", "此金額以上"),
    remoteAreaList: build("Remote Area List", "偏遠地區列表", "偏远地区列表"),
    excludeSubDistrictCharge: build("Don't Apply Remote Area Additional Fee", "停用偏遠地區附加費", "停用偏远地区附加费"),
    excludeShipOptions: build("Exclude Ship Options", "停用運送選項", "停用运送选项"),
    subDistrictChargeList: build("Remote Area Additional Fee List", "偏遠地區附加費列表", "偏远地区附加费列表"),
    country: build("Country / Region", "國家 / 地區", "國家 / 地區"),
    addr: build("Address", "地址", "地址"),
    region: build("Region", "區域", "區域"),
    district: build("Area", "區域", "區域"),
    location: build("Location", "位置", "位置"),
    subDistrict: build("District", "地區", "地區"),
    code: build("Code", "編號", "編號"),
    shippingCode: build("Shipping Code", "運輸代碼", "运输代码"),
    servicePartner: build("Service Partner", "服務提供商", "服務提供商"),
    shippingMethod: build("Shipping Method", "運送方式", "運送方式"),
    beConsideredInFreeShipping: build("Be Considered In Free Shipping", "計入免運費", "计入免运费"),
    recipientName: build("Recipient Name", "收件人", "收件人"),
    telCountryCode: build("Country", "電話區號", "電話區號"),
    companyName: build("Company Name", "公司名稱", "公司名称"),
    companyAddress: build("Company Address", "公司地址", "公司地址"),
    companyNameO: build("Company Name (optional)", "公司名稱 (可選)", "公司名称 (可选)"),
    companyAddressO: build("Company Address (optional)", "公司地址 (可選)", "公司地址 (可选)"),
    zipcode: build("Zip Code", "郵政編碼", "邮政编码"),
    city: build("City", "城市", "城市"),
    state: build("State", "州 / 省", "州 / 省"),
    addRestriction: build("Add Fee Option Restriction", "新增費用選項限制", "添加费用选项限制"),
    pickupType: build("Pickup Type", "拾音器類型", "拾音器类型"),
    regularPickup: build("Regular Pickup", "定期取貨", "定期取货"),
    scheduledPickup: build("Scheduled Pickup", "預約取貨", "预约取货"),
    scheduleType: build("Schedule Type", "日程表類型", "日程表类型"),
    selectPickup: build("Select Pickup Address", "選擇取貨地址", "选择取货地址"),
  },
  pay: {
    add: build("Add Payment Setting", "新增付款設定", "新增付款設定"),
    payType: build("Pay Type", "付款方式", "付款方式"),
    cod: build("Offline Payment", "線下付款", "線下付款"),
    paypal: build("PayPal", "PayPal", "PayPal"),
    kpay: build("Kpay", "Kpay", "Kpay"),
    payme: build("Payme", "payme", "payme"),
    paymentGatewayKey: build("Payment Gateway Key", "支付網關金鑰", "支付网关金钥"),
    stripe: build("Stripe", "Stripe", "Stripe"),
    freePayment: build("No Cost Payment", "免費付款", "免费付款"),
    name: build("Name", "名稱", "名稱"),
    edit: build("Edit Payment Setting", "修改付款設定", "修改付款設定"),
    codMessage: build("COD Message", "線下付款訊息", "線下付款訊息"),
    paymentOnDelivery: build("Payment On Delivery", "貨到付款", "货到付款"),
    removePaySettingConfirmation: build("Remove Payment Setting Confirmation", "移除付款設定確認", "移除付款設定確認"),
  },
  language: {
    en: build("English", "英文", "英文"),
    zhHant: build("Chinese (Traditional)", "繁體中文", "繁體中文"),
    zhHans: build("Chinese (Simplified)", "簡體中文", "簡體中文"),
  },
  pickupAddr: {
    pickupAddr: build("Store Pickup Address", "自取點地址", "自取點地址"),
    addNew: build("Add New Address", "新增自取點", "新增自取點"),
    add: build("Add", "新增", "新增"),
    address: build("Address", "地址", "地址"),
    openingHour: build("Opening Hour", "營業時間", "營業時間"),
    tel: build("Tel", "電話號碼", "電話號碼"),
    name: build("Name", "名稱", "名称"),
    direction: build("Directions", "路線指引", "路线指引"),
  },
  country: {
    country: build("Shipping Region", "運送地區", "運送地區"),
    pleaseSelect: build("Please Select Shipping Region", "請選擇運送地區", "請選擇運送地區"),
    search: build("Search", "搜尋", "搜尋"),
  },
  form: {
    send: build("Send", "發送", "發送"),
    close: build("Close", "關閉", "關閉"),
    form: build("Form", "表單", "表單"),
    dropYourFilesHere: build("Drop Your File Here", "拖移檔案到此", "拖移檔案到此"),
    select: build("Select", "選擇", "选择"),
    add: build("Add", "新增", "新增"),
    update: build("Update", "更新", "更新"),
    remove: build("Remove", "刪除", "刪除"),
    edit: build("Edit", "修改", "修改"),
    cancel: build("Cancel", "取消", "取消"),
    hide: build("Hide", "隱藏", "隐藏"),
    create: build("Create", "新增", "新增"),
    submit: build("Submit", "提交", "提交"),
    submitting: build("Submitting...", "提交中...", "提交中..."),
    success: build("Success", "成功", "成功"),
    delete: build("Delete", "刪除", "刪除"),
    save: build("Save", "儲存", "儲存"),
    saving: build("Saving...", "儲存中...", "儲存中..."),
    test: build("Test", "測試", "测试"),
    emailR: build("Email Address Is Required", "電郵是必需的", "電郵是必需的"),
    uploading: build("Uploading", "上傳中", "上传中"),
    emailInvalid: build("Email Address Format Is Invalid", "電郵地址格式錯誤", "電郵地址格式錯誤"),
    required: build("Is Required", "必需填寫", "必需填写"),
    formatInvalid: build("Format Is Invalid", "格式錯誤", "格式错误"),
    fileName: build("File Name", "檔案名稱", "档案名称"),
    upload: build("Upload", "上傳", "上传"),
    uploaded: build("Uploaded", "上載完成", "上载完成"),
    min: build("Min", "最少值", "最少值"),
    max: build("Max", "最大值", "最大值"),
    bulkActions: build("Bulk Actions", "批次操作", "批次操作"),
    selectForBatchActions: build("Select Below Rows For Batch Operation", "選擇以下行進行批次操作", "选择以下行进行批次操作"),
  },
  formSubmit: {
    createForm: build("Create Form", "新增表單", "新增表单"),
    editForm: build("Edit Form", "更新表單", "更新表單"),
    emailSubject: build("Email Subject", "電郵主題", "電郵主题"),
    formSubmittedList: build("Submitted Records", "提交記錄", "提交记录"),
  },
  import: {
    importProduct: build("Import Product", "產品匯入", "产品汇入"),
    import: build("Import", "匯入", "汇入"),
    importing: build("Importing...", "匯入中...", "汇入中..."),
    success: build("Success", "成功", "成功"),
    error: build("Error", "錯誤", "錯誤"),
    exportWholeShop: build("Export Whole Shop", "匯出整個商店", "汇出整个商店"),
    importWholeShop: build("Import Full Shop", "匯入整個商店", "汇入整个商店"),
    importExportWholeShop: build("Import / Export Whole Shop", "滙入/匯出整個商店", "汇入/汇出整个商店"),
    importLegacy: build("Import Legacy"),
    importProductImages: build("Import Product Images", "產品圖片匯入", "产品图片汇入"),
    importCategory: build("Import Category", "產品類別匯入", "产品类别汇入"),
    importBrand: build("Import Brand", "產品品牌匯入", "产品品牌汇入"),
    importProductCatAssocation: build("Product - Category Association", "產品 - 類別 關聯匯入", "产品 - 类别 关联汇入"),
    legacyId: build("Legacy Id"),
    legacyUser: build("Legacy User"),
    legacySalt: build("Password Salt"),
    legacyHash: build("Password Hash"),
    legacyType: build("Legacy System"),
    legacyOrder: build("Legacy Order"),
    legacyOrderId: build("Legacy Order ID", "舊訂單編號", "旧订单编号"),
    currency: build("Currency"),
    countryCode: build("Country Code"),
    createdAt: build("Created At", "建立日期", "建立日期"),
    updatedAt: build("Updated At", "更新日期", "更新日期"),
    rewardPoints: build("Points"),
    firstName: build("First Name"),
    lastName: build("Last Name"),
    productNotFound: build("Product Not Found", "未找到產品", "未找到产品"),
  },
  discount: {
    scheduleDiscount: build("Schedule Discount", "折扣時間表", "折扣时间表"),
    discount: build("Discount", "折扣", "折扣"),
    productDiscounts: build("Product Discounts", "產品折扣", "产品折扣"),
    addScheduleDiscount: build("Add Schedule Discount", "新增折扣時間表", "新增折扣时间表"),
    schedule: build("Schedule", "日程表", "日程表"),
    attachToCategories: build("Attach To Categories", "綁定產品類別", "綁定產品類別"),
    attachToProducts: build("Attach To Products", "綁定產品", "綁定產品"),
    attachDiscount: build("Attach Discount", "附加折扣", "附加折扣"),
    products: build("Products", "產品", "產品"),
    categories: build("Categories", "產品類別", "產品類別"),
    global: build("Global", "全部", "全部"),
    discountType: build("Discount Type", "折扣類型", "折扣类型"),
    percentage: build("Percentage", "百分比", "百分比"),
    discountPrice: build("Discount Price", "折扣價格", "折扣价格"),
    discountPercentage: build("Discount Percentage", "折扣百分比", "折扣百分比"),
    priceAfterDiscount: build("Price After Discount", "折扣後價格", "折扣后价格"),
    startDate: build("Start Date", "開始日期", "开始日期"),
    status: build("Discount Status", "折扣狀態", "折扣状态"),
    endDate: build("End Date", "結束日期", "结束日期"),
    editScheduleDiscount: build("Edit Schedule Discount", "更改折扣時間表", "更改折扣时间表"),
    fixedAmt: build("Fixed Amount", "固定金額", "固定金额"),
    byCategories: build("By Categories", "產品類別", "产品类别"),
    byProducts: build("By Products", "產品", "产品"),
    tier: build("Tier", "層級", "层级"),
    threshold: build("Threshold", "門檻", "门槛"),
    maxQuantity: build("Max Quantity", "最大數量", "最大数量"),
    scheduleDiscountMode: build("Schedule discount mode", "折扣模式", "折扣模式"),
    scheduleDiscountKindSimple: build("Simple", "基本折扣", "基本折扣"),
    scheduleDiscountKindBuyX: build("Buy X get Y% off", "滿X件減Y%", "满X件减Y%"),
    buyXMinBuyQty: build("Min buy quantity", "最低購買件數", "最低购买件数"),
    buyXAddTier: build("Add tier", "新增層級", "新增层级"),
    buyXRemoveTier: build("Remove tier", "移除層級", "移除层级"),
    buyXMaxDiscountedUnits: build("Max discounted units (optional)", "最多折扣件數（可選）", "最多折扣件数（可选）"),
  },
  placement: {
    retail: build("Retail", "零售", "零售"),
    toAllRetails: build("All retail shops", "全部零售店", "全部零售店"),
    eshop: build("eShop", "網上商店", "网上商店"),
    both: build("Both", "全部", "全部"),
    editDiscount: build("Edit Discount", "編輯折扣", "编辑折扣"),
    location: build("Location", "地點", "地点"),
    selectLocations: build("Select Locations", "選擇地點", "选择位置"),
  },
  addOnDiscount: {
    addOnDiscount: build("Add-On Discount", "加購優惠", "加购优惠"),
    addAddOnDiscount: build("Create Add-On Discount", "新增加購優惠", "新增加购优惠"),
    editAddOnDiscount: build("Edit Add-On Discount", "修改加購優惠", "修改加购优惠"),
    name: build("Offer Name", "優惠名稱", "优惠名称"),
    description: build("Description", "優惠描述", "优惠描述"),
    placement: build("Place At", "投放位置", "投放位置"),
    checkout: build("Checkout", "結賬", "结账"),
    scope: build("Applying Scope", "應用範圍", "应用范围"),
    triggerCriteria: build("Triggering Criteria", "觸發條件", "触发条件"),
    addOnProducts: build("Add On Products", "加購產品", "加购产品"),
    type: build("Select By", "選擇依據", "选择依据"),
  },
  coupon: {
    coupon: build("Coupons", "優惠券", "優惠券"),
    addCoupon: build("Add Coupon", "新增優惠券", "新增優惠券"),
    editCoupon: build("Edit Coupon", "更改優惠券", "更改優惠券"),
    issueMode: build("Issue Mode", "發放模式", "发放模式"),
    eligibility: build("Eligibility", "使用條件", "使用条件"),
    placement: build("Placement", "適用場景", "适用场景"),
    combineWithOtherCoupon: build("Combine With Other Coupon", "可與其他優惠券組合", "可与其他优惠券组合"),
    priority: build("Priority", "優先級", "优先级"),
    autoApply: build("Auto Apply (Redeem) Coupon", "自動應用（兌換）優惠券", "自动应用（兑换）优惠券"),
    minOrderAmount: build("Min Order Amount", "最低訂單金額", "最低订单金额"),
    userUsageLimit: build("User Usage Limit", "用戶使用次數限制", "用户使用次数限制"),
    userUsageLimitDuration: build("User Usage Limit Duration (days)", "用戶使用限制時長（天）", "用户使用限制时长（天）"),
    shopUsageLimit: build("Shop Usage Limit", "商店使用次數限制", "商店使用次数限制"),
    shopUsageLimitDuration: build("Shop Usage Limit Duration (days)", "商店使用限制時長（天）", "商店使用限制时长（天）"),
    discountPercentage: build("Discount Percentage", "折扣百分比", "折扣百分比"),
    discountAmount: build("Discount Amount", "折扣金額", "折扣金额"),
    startDate: build("Start Date", "開始日期", "开始日期"),
    expiration: build("Expiration", "有效期", "有效期"),
    expirationType: build("Expiration Type", "有效期類型", "有效期类型"),
    expirationDay: build("Expiration Day", "有效期天數", "有效期天数"),
    accountCreatedAfter: build("User Account Created After", "使用者帳戶建立時間", "用户帐户创建时间"),
    includeMemberships: build("Include Memberships", "包含會員等級", "包含会员等级"),
    excludeMemberships: build("Exclude Memberships", "排除會員等級", "排除会员等级"),
    addIncludeMemberships: build("Add Include Memberships", "新增包含會員等級", "新增包含会员等级"),
    addExcludeMemberships: build("Add Exclude Memberships", "新增排除會員等級", "新增排除会员等级"),
    includeCategories: build("Include Categories", "包含分類", "包含分类"),
    excludeCategories: build("Exclude Categories", "排除分類", "排除分类"),
    addIncludeCategories: build("Add Include Categories", "新增包含分類", "新增包含分类"),
    addExcludeCategories: build("Add Exclude Categories", "新增排除分類", "新增排除分类"),
    includeProducts: build("Include Products", "包含產品", "包含产品"),
    excludeProducts: build("Exclude Products", "排除產品", "排除产品"),
    addIncludeProducts: build("Add Include Products", "新增包含產品", "新增包含产品"),
    addExcludeProducts: build("Add Exclude Products", "新增排除產品", "新增排除产品"),
    code: build("Code", "編號", "編號"),
    confirmDelete: build("Confirm Delete Coupon", "確認刪除優惠券", "确认删除优惠券"),
    confirmDeleteMessage: build(
      "Are you sure you want to delete this coupon? This action cannot be undone.",
      "您確定要刪除此優惠券嗎？此操作無法撤銷。",
      "您确定要删除此优惠券吗？此操作无法撤销。"
    ),
  },
  reward: {
    reward: build("Reward", "積分", "積分"),
    rewards: build("Rewards", "積分", "積分"),
    isRewardRedeemable: build("Can Deduct Reward From Product", "可以從產品中扣除獎勵", "可以从产品中扣除奖励"),
    add: build("Add Reward", "新增積分", "新增积分"),
    points: build("Reward Points", "獎勵積分", "奖励积分"),
    pointsShort: build("Points", "積分", "积分"),
    rewardStatus: build("Status", "狀態", "状态"),
    active: build("Active", "生效", "生效"),
    pending: build("Pending", "待處理", "待处理"),
    create: build("Create Reward", "建立積分", "建立积分"),
    purchaseDate: build("Purchase Date", "購買日期", "购买日期"),
    customerId: build("Customer Id", "客戶 ID", "客户 ID"),
    orderNumber: build("Order Number (Optional)", "訂單號碼（可選）", "订单号码（可选）"),
    orderNumberText: build(
      "order number must be for an order by this user",
      "訂單號碼必須是此用戶的訂單",
      "订单号码必须是此用户的订单"
    ),
    expired: build("Expired", "已過期", "已过期"),
    shopDollar: build("Shop Dollar", "Shop Dollar", "Shop Dollar"),
    customerName: build("Customer Name", "客戶姓名", "客户姓名"),
    selectAnORder: build("Select An Order", "選擇訂單", "选择订单"),
    expiresOn: build("Expires On", "到期日", "到期日"),
    redeemed: build("Used", "已使用", "已使用"),
    showBalanceAdjustment: build("Show Balance Adjustment", "顯示餘額調整", "显示余额调整"),
    hideBalanceAdjustment: build("Hide Balance Adjustment", "隱藏餘額調整", "隐藏余额调整"),
    currentBalance: build("Current Balance", "當前餘額", "当前余额"),
    targetBalance: build("Target Balance", "目標餘額", "目标余额"),
    expirationDate: build("Expiration Date", "到期日期", "到期日期"),
    adjustBalance: build("Adjust Balance", "調整餘額", "调整余额"),
  },
  membership: {
    activate: build("Activate Membership", "啟動會員資格", "激活会员资格"),
    areYouSureActivate: build(
      "Are you sure you want to activate this membership",
      "您確定要啟動此會員資格嗎",
      "您确定要激活此会员资格吗"
    ),
    createTier: build("Create Membership Tier", "建立會員等級", "创建会员等级"),
    create: build("Create Membership", "建立會員資格", "创建会员资格"),
    deactivate: build("Deactivate Membership", "取消會員資格", "取消会员资格"),
    areYouSureDeactivate: build(
      "Are you sure you want to deactivate this membership",
      "您確定要停用此會員資格嗎",
      "您确定要停用此会员资格吗"
    ),
    edit: build("Edit Membership", "編輯會員資格", "编辑会员资格"),
    firstTimeIssue: build("Issue to First Time Customer", "發給首次顧客", "发给首次顾客"),
    issueCriteria: build("Issue Criteria", "發放要求", "发放要求"),
    activationMethod: build("Method of Activation", "激活方法", "激活方法"),
    membership: build("Membership", "會員資格", "会员资格"),
    priority: build("Priority", "優先次序", "优先次序"),
    validityPeriod: build("Membership Duration (Days)", "會員期限（天）", "会员期限（天）"),
    activationDate: build("Activation Date", "啟用日期", "激活日期"),
    expiration: build("Expiration Date", "截止日期", "截止日期"),
    activeMemberships: build("Active Memberships", "活躍會員", "活跃会员"),
    minTriggerAmount: build("Min Trigger Amount", "最低觸發金額", "最低触发金额"),
    orderDurationDay: build("Order Duration (Day)", "訂單期限 (天)", "订单期限 (天)"),
    active: build("Activate", "啟用設定", "激活"),
    editMembership: build("Edit Membership", "編輯會員資格", "编辑会员资格"),
    editMemebershipDetails: build("Edit the following membership details", "编辑以下会员详细信息", "編輯以下會員詳細信息"),
    add: build("Add", "新增", "新增"),
    selectMembership: build("Select Membership", "選擇會員等級", "选择会员等级"),
    noMembershipsAvailable: build("No memberships available", "沒有可用的會員等級", "没有可用的会员等级"),
    overrideExpiration: build(
      "The date below is a manual override, for the expiration date",
      "以下日期為手動覆蓋，為到期日期",
      "以下日期为手动覆盖，为到期日期"
    ),
    manualEXpiration: build("Manual Expiration Date Override", "手動覆蓋到期日", "手动覆盖到期日期"),
    includeMemberships: build("Include Memberships", "包含會員等級", "包含会员等级"),
    excludeMemberships: build("Exclude Memberships", "排除會員等級", "排除会员等级"),
    defaultTier: build("Default Membership", "預設會員等級", "默认会员等级"),
    defaultTierBadge: build("Default", "預設", "默认"),
    rewardMultiplier: build("Reward Multiplier", "積分倍數", "积分倍数"),
    rewardMultiplierInfo: build("1 = normal rate, 2 = double points", "1 = 正常比率，2 = 雙倍積分", "1 = 正常比率，2 = 双倍积分"),
    currentTier: build("Current Tier:", "現有級別:", "现有级别:"),
    upgradeCriteria: build("Upgrade Criteria", "升級條件", "升级条件"),
    maintainCriteria: build("Maintain Criteria", "維持條件", "维持条件"),
    tierUpgradeSpend: build("Tier (Upgrade Spend Required)", "會員級別 (升級所需消費)", "会员级别 (升级所需消费)"),
    calcPeriod: build("Calculation Period", "計算期間", "计算期间"),
    pastNDays: build("Past {n} days spending", "過去{n}日消費", "过去{n}日消费"),
    amountSpent: build("Amount Spent", "已消費金額", "已消费金额"),
    remainingAmount: build("Remaining Amount", "尚餘金額", "尚余金额"),
    dateRange: build("Date Range", "日期", "日期"),
    spentBeforeExpiration: build("Spent Before Expiration", "到期前消費總額", "到期前消费总额"),
  },
  giftCard: {
    startDate: build("Start Date", "開始日期", "开始日期"),
    create: build("Create Gift Card", "創建禮品卡", "创建礼品卡"),
    createGiftCardType: build("Create Gift Card Type", "創建禮品卡類型", "创建礼品卡类型"),
    edit: build("Edit Gift Card", "編輯禮品卡", "编辑礼品卡"),
    giftCard: build("Gift Card", "禮品卡", "礼品卡"),
    giftCards: build("Gift Cards", "禮品卡", "礼品卡"),
    giftCardType: build("Gift Card Type", "禮品卡類型", "礼品卡类型"),
    giftCardTypes: build("Gift Card Types", "禮品卡類型", "礼品卡类型"),
    giftCardDef: build("Gift Card Definition", "禮品卡定義", "礼品卡定义"),
    validityPeriod: build("Gift Card Validity (Days)", "禮品卡有效期限（天）", "礼品卡有效期（天）"),
    value: build("Value", "價值", "价值"),
    balance: build("Balance", "餘額", "余额"),
    used: build("Used", "已使用", "已使用"),
    active: build("Active", "生效", "生效"),
    expired: build("Expired", "已過期", "已过期"),
    cancelled: build("Cancelled", "已取消", "已取消"),
    seeMore: build("See More", "查看更多", "查看更多"),
    exiresOn: build("Expires On", "到期日", "到期日"),
    aggregationMode: build("Aggregation Mode", "集合模式", "集合模式"),
    allowAggregation: build("Allow Aggregation", "允許", "允许"),
    noAggregation: build("None", "不適用", "不适用"),
    excludeProducts: build("Exclude Products", "排除產品", "排除产品"),
    excludeCategories: build("Exclude Categories", "排除分類", "排除分类"),
  },
  giftPromotion: {
    giftPromotion: build("Gift Promotion", "贈品推廣", "赠品推广"),
    giftPromotions: build("Gift Promotions", "贈品推廣", "赠品推广"),
    add: build("Add Gift Promotion", "新增贈品推廣", "新增赠品推广"),
    edit: build("Edit Gift Promotion", "編輯贈品推廣", "编辑赠品推广"),
    create: build("Create Gift Promotion", "建立贈品推廣", "建立赠品推广"),
    name: build("Name", "名稱", "名称"),
    code: build("Code", "代碼", "代码"),
    status: build("Status", "狀態", "状态"),
    statusActive: build("Active", "啟用", "启用"),
    statusDraft: build("Draft", "草稿", "草稿"),
    statusInactive: build("Inactive", "停用", "停用"),
    pause: build("Pause", "暫停", "暂停"),
    resume: build("Resume", "恢復", "恢复"),
    delete: build("Delete", "刪除", "删除"),
    confirmDelete: build("Confirm Delete", "確認刪除", "确认删除"),
    confirmDeleteMessage: build(
      "Are you sure you want to delete this gift promotion?",
      "您確定要刪除此贈品推廣嗎？",
      "您确定要删除此赠品推广吗？"
    ),
    matchingCriteria: build("Matching Criteria", "匹配條件", "匹配条件"),
    triggerType: build("Trigger Type", "觸發類型", "触发类型"),
    triggerTypeQuantity: build("Quantity", "數量", "数量"),
    triggerTypeAmount: build("Amount", "金額", "金额"),
    triggerTypeBoth: build("Both", "兩者", "两者"),
    buyQuantity: build("Buy Quantity", "購買數量", "购买数量"),
    minOrderAmount: build("Min Order Amount", "最低訂單金額", "最低订单金额"),
    eligibility: build("Eligibility", "資格", "资格"),
    withOtherPromotions: build("With Other Promotions", "與其他推廣一起使用", "与其他推广一起使用"),
    validity: build("Validity", "有效期", "有效期"),
    startDate: build("Start Date", "開始日期", "开始日期"),
    endDate: build("End Date", "結束日期", "结束日期"),
    payoutCriteria: build("Payout Criteria", "派發條件", "派发条件"),
    payoutType: build("Payout Type", "派發類型", "派发类型"),
    payoutTypeQuantity: build("Quantity", "數量", "数量"),
    payoutTypeAmount: build("Amount", "金額", "金额"),
    payoutTypeTiered: build("Tiered", "分層", "分层"),
    giftQuantity: build("Gift Quantity", "贈品數量", "赠品数量"),
    autoStack: build("Auto Stack", "自動堆疊", "自动堆叠"),
    maxStack: build("Max Stack", "最大堆疊", "最大堆叠"),
    giftItems: build("Gift Items", "贈品項目", "赠品项目"),
    giftItemsNote: build(
      "Gift items configuration will be added in future updates",
      "贈品項目配置將在未來更新中添加",
      "赠品项目配置将在未来更新中添加"
    ),
    tiers: build("Tiers", "層級", "层级"),
    threshold: build("Threshold", "門檻", "门槛"),
    fallbackGifts: build("Fallback Gifts", "候補禮物", "候补礼物"),
    excludeProducts: build("Exclude Products", "排除產品", "排除产品"),
    excludeCategories: build("Exclude Categories", "排除分類", "排除分类"),
    fallbackGift: build("Fallback Gift", "候補禮物", "候补礼物"),
    addFallbackGift: build("Add Fallback Gift", "新增候補禮物", "新增候补礼物"),
    priority: build("Priority", "優先級", "优先级"),
  },
  delivery: {
    deliveryOrder: build("Delivery Note", "出貨單", "出貨單"),
    deliveryOrderDownloadError: build("Failed to download delivery note", "下載出貨單失敗", "下载出货单失败"),
    addAVehicle: build("Add a vehicle", "新增車輛", "新增车辆"),
    trackingId: build("Tracking Id", "追蹤 ID", "追踪 ID"),
    district: build("District", "地區", "地区"),
    address: build("Address", "地址", "地址"),
    deliveryStatus: build("Delivery Status", "出貨狀態", "出貨狀態"),
    status: build("Status", "狀態", "状态"),
    notAvailable: build("Not Available", "未有狀態", "未有状态"),
    assign: build("Assign", "指派", "指派"),
    addVehicle: build("Add Vehicle", "新增車輛", "新增车辆"),
    car: build("Car", "車", "车"),
    createSchedule: build("Create Delivery Schedule", "建立交貨計劃", "创建交货计划"),
    deliveries: build("Deliveries", "配送", "配送"),
    editVehicle: build("Edit Vehicle", "編輯車輛", "编辑车辆"),
    licensePlate: build("License Plate", "車牌", "车牌"),
    maintenance: build("Maintenance", "維護", "维护"),
    motorcycle: build("Motorcycle", "摩托車", "摩托车"),
    scheduled: build("Scheduled", "待處理", "待处理"),
    preparing: build("Preparing", "執緊貨", "备货中"),
    onDelivery: build("On Delivery", "已寄出", "已寄出"),
    canPickup: build("Can Pickup", "可自取", "可自取"),
    cancelled: build("Cancelled", "已取消", "已取消"),
    truck: build("Truck", "貨車", "货车"),
    unavailable: build("Unavailable", "不可用", "不可用"),
    vehicleName: build("Vehicle Name", "車輛名稱", "车辆名称"),
    vehicles: build("Vehicles", "車輛", "车辆"),
    noPendingOrdersForDelivery: build("No Pending Orders For Delivery", "沒有待處理的訂單", "没有待处理的订单"),
    selectOrderItemsAndVehicleToContinue: build(
      "Select Order Items and Vehicle to Continue",
      "選擇訂單項目和車輛以繼續",
      "选择订单项目和车辆以继续"
    ),
    deliveryOptions: build("Delivery Options", "配送選項", "配送选项"),
    deliveryNote: build("Delivery Note", "配送備註", "配送备注"),
    noDeliveryNote: build("No delivery note", "無配送備註", "无配送备注"),
    editDeliveryNote: build("Edit Delivery Note", "編輯配送備註", "编辑配送备注"),
    enterDeliveryNote: build("Enter delivery note...", "輸入配送備註...", "输入配送备注..."),
    deliveryHasRecycle: build("Has Recycle Items", "有回收物品", "有回收物品"),
    recycleRequired: build("Recycle Required", "需要回收", "需要回收"),
    noRecycleRequired: build("No Recycle Required", "無需回收", "无需回收"),
    deliveryFrontDoorDropOff: build("Front Door Drop-off", "可放門口或管理處", "可放门口或管理处"),
    frontDoorDropOffEnabled: build("Front Door Drop-off Enabled", "已啟用前門投遞", "已启用前门投递"),
    frontDoorDropOffDisabled: build("Front Door Drop-off Disabled", "已停用前門投遞", "已停用前门投递"),
    items: build("Items", "項目", "项目"),
    hasRecycle: build("Has Recycle", "有回收物品", "有回收物品"),
    frontDoorDropOff: build("Front Door Drop-off", "可放門口或管理處", "可放门口或管理处"),
    excludeWeekDays: build("Exclude Weekdays", "排除工作日", "排除工作日"),
    excludeDates: build("Exclude Dates", "排除日期", "排除日期"),
    assignModePrepared: build("Schedule route (vehicle & date)", "安排路線（車輛與日期）", "安排路线（车辆与日期）"),
    assignModeDraft: build("Save as draft batch", "存為草稿批次", "保存为草稿批次"),
    assignModeAppend: build("Add to existing batch", "加入現有批次", "加入现有批次"),
    selectBatch: build("Select batch", "選擇批次", "选择批次"),
    preparingBatches: build("Draft delivery batches", "草稿配送批次", "草稿配送批次"),
    draftScheduleLabel: build("Draft schedule", "草稿時間表", "草稿时间表"),
    shippingSnapshot: build("Shipping (delivery batch)", "配送地址（批次）", "配送地址（批次）"),
    finalizeRun: build("Finalize — set vehicle & date", "完成 — 設定車輛與日期", "完成 — 设定车辆与日期"),
    addrTypeRegular: build("Regular address", "一般地址", "一般地址"),
    addrTypeSf: build("S.F. location", "順豐點", "顺丰点"),
    addrTypePickup: build("Store pickup", "門市自取", "门市自取"),
  },
  report: {
    reports: build("Reports", "報表", "報表"),
    topEarnings: build("Top Earnings", "最高收入", "最高收入"),
    trendingProducts: build("Trending Products", "熱門產品", "热门产品"),
    sales1W: build("Sales 1W", "銷售 1W", "销售 1W"),
    sales1M: build("Sales 1M", "銷售 1M", "销售 1M"),
    sales1Y: build("Sales 1Y", "銷售 1Y", "销售 1Y"),
    percentage1W: build("% 1W", "% 1W", "% 1W"),
    percentage1M: build("% 1M", "% 1M", "% 1M"),
    percentage1Y: build("% 1Y", "% 1Y", "% 1Y"),
    sortViaPrice: build("Sort via pricing", "按價格排序", "按价格排序"),
    sales: build("Sales", "銷售", "销售"),
    WTopSales: build("1W Top Sales", "1W 最高銷售", "1W 最高销售"),
    WLeastSales: build("1W Least Sales", "1W 最低銷售", "1W 最低销售"),
    MTopSales: build("1M Top Sales", "1M 最高銷售", "1M 最高销售"),
    MLeastSales: build("1M Least Sales", "1M 最低銷售", "1M 最低销售"),
    YTopSales: build("1Y Top Sales", "1Y 最高銷售", "1Y 最高销售"),
    YLeastSales: build("1Y Least Sales", "1Y 最低銷售", "1Y 最低销售"),
    byOrder: build("By Order", "按訂單", "按订单"),
    byDate: build("By Date", "按日期", "按日期"),
    byCustomer: build("By Customer", "按客戶", "按客户"),
    filterBy: build("Filter By", "過濾依據", "过滤依据"),
    totalOrders: build("Total Orders", "總訂單數", "总订单数"),
    totalSales: build("Total Sales", "總銷售額", "总销售额"),
    cost: build("Cost", "成本", "成本"),
    profit: build("Profit", "利潤", "利润"),
    revenue: build("Revenue", "收入", "收入"),
    salesReport: build("Sales Report", "銷售報表", "销售报表"),
    profitReport: build("Profit Report", "利潤報表", "利润报表"),
    hourlyReport: build("Hourly Report", "每小時報表", "每小时报表"),
    hour: build("Hour", "小時", "小时"),
    groupBy: build("Group By", "分組依據", "分组依据"),
    due: build("Due", "到期", "到期"),
    completed: build("Completed", "已完成", "已完成"),
    canceled: build("Canceled", "已取消", "已取消"),
  },
  order: {
    combinedOrder: build("Combined Order", "合併訂單", "合并订单"),
    orderItems: build("Order Items", "訂單項目", "订单项目"),
    comment: build("Comment", "註釋", "注释"),
    create: build("Create Order", "新增訂單", "新增訂單"),
    orders: build("Orders", "訂單", "订单"),
    order: build("Order", "訂單", "订单"),
    status: build("Status", "狀態", "状态"),
    date: build("Date", "日期", "日期"),
    orderStatus: build("Order Status", "訂單狀態", "订单状态"),
    amount: build("Amount", "金額", "金额"),
    paymentType: build("Payment Type", "付款方式", "付款方式"),
    paymentStatus: build("Payment Status", "付款狀態", "付款状态"),
    shippingMethod: build("Shipping Method:", "送貨方式：", "送貨方式："),
    orderNumber: build("Order Number", "訂單編號", "订单编号"),
    processing: build("Processing", "處理中", "处理中"),
    pending: build("Pending", "待處理", "待处理"),
    shipped: build("Shipped", "已寄出", "已寄出"),
    delivered: build("Delivered", "已收貨", "已收貨"),
    returned: build("Returned", "退貨", "退货"),
    cancelled: build("Cancelled", "取消", "取消"),
    customer: build("Customer", "客戶", "客戶"),
    itemsTotal: build("Items Total", "產品總額", "产品总额"),
    shipFee: build("Shipping Fee", "運費", "运费"),
    total: build("Total", "總金額", "总金额"),
    price: build("Price", "價格", "价格"),
    earnedPoints: build("Earned Point:", "獲得積分:", "获得积分:"),
    usedPoints: build("Used Point", "使用積分", "使用积分"),
    addNote: build("Add Note", "新增備註", "新增備註"),
    writeNote: build("Write Note", "輸入備註", "輸入備註"),
    note: build("Note", "備註", "備註"),
    updateStatusTitle: build("Update Order Status", "更新訂單狀態", "更新订单状态"),
    updateStatusMsg: build(
      "Do you want to update order status  to Shipped?",
      "您想將訂單狀態更新為「已出貨」嗎？",
      "您想将订单状态更新为「已发货」吗？"
    ),
    orderDate: build("Order Date"),
    preOrderDate: build("Arrival Date", "抵達日期", "抵达日期"),
    view: build("View Order", "查看订单", "查看訂單"),
    cancelOrder: build("Cancel order", "取消订单", "取消訂單"),
    createTestOrders: build("Create Test Orders", "新增測試訂單", "新增測試訂單"),
    downloadOrders: build("Download Orders", "下載訂單", "下载订单"),
    selectDownloadFormat: build("Please select below download format:", "請選擇以下的下載格式：", "请选择以下的下载格式："),
    orderListFilter: build("Order List Filter", "訂單列表篩選", "订单列表筛选"),
    generatePaymentLink: build("Show Direct Payment Link", "顯示直接付款連結", "显示直接付款链接"),
    hide: build("Hide Direct Payment Link", "隱藏直接付款鏈接", "隐藏直接付款链接"),
    noPaymentProof: build("No Payment Yet", "無付款證明", "无付款证明"),
    orderTotal: build("Order Total", "訂單總計", "订单总额"),
    subTotal: build("SubTotal", "小計", "小計"),
    quantity: build("Quantity", "數量", "数量"),
    unitprice: build("Unit Price", "單價", "单价"),
    discount: build("Discount", "折扣", "折扣"),
    couponDiscount: build("Coupon Discount", "優惠券折扣", "优惠券折扣"),
    giftCardDiscount: build("Gift Card Discount", "禮品卡折扣", "礼品卡折扣"),
    rewardRedeemed: build("Reward Redeemed", "已兌換獎勵", "已兑换奖励"),
    resendOrderConfirmation: build("Resend Order Confirmation", "重新發送訂單確認", "重新发送订单确认"),
    membershipDiscount: build("Membership Discount", "會員折扣", "会员折扣"),
    giftCardOrShopdollarUsed: build("GiftCard Used", "已使用礼品卡", "已使用禮品卡"),

    couponUsed: build("Coupon Used", "已使用優惠券", "已使用优惠券"),
    stockHoldStatus: build("Stock Status", "庫存狀態", "库存状态"),
  },
  paymentPortion: {
    fullPayment: build("Full Payment", "全款付款", "全款付款"),
    partPayment: build("Partial Payment", "部分付款", "部分付款"),
    deposit: build("Deposit", "按金", "押金"),
    balance: build("Balance", "餘額", "余额"),
    amountRecieved: build("Amount Received", "已收款金額", "已收款金额"),
    paymentProof: build("Payment Proof", "付款證明", "付款证明"),
    paymentMethod: build("Payment Method", "付款方式", "付款方式"),
    paymentType: build("Payment Type", "付款類型", "付款类型"),
    noProof: build("No Proof", "無證明", "无证明"),
    updateProof: build("Update Proof", "更新證明", "更新证明"),
    addProof: build("Add Proof", "新增證明", "新增证明"),
    uploading: build("Uploading", "上傳中", "上传中"),
  },
  payment: {
    payments: build("Payment", "付款", "付款"),
    awaiting: build("Awaiting", "未付款", "未付款"),
    paid: build("Paid", "已付款", "已付款"),
    refunded: build("Refunded", "已退款", "已退款"),
    deposit: build("Deposit", "按金", "押金"),
    partialPayment: build("Partial Payment", "部分付款", "部分付款"),
    cod: build("Cash On Devliery", "貨到付款", ""),
    paypal: build("PayPal", "PayPal", "PayPal"),
    stripe: build("Stripe", "Stripe", "Stripe"),
    addPayment: build("Add Payment", "新增付款", "新增付款"),
    editPayment: build("Edit Payment", "編輯付款", "编辑付款"),
    removePayment: build("Remove Payment", "刪除付款", "删除付款"),
    kpayGatewayPayment: build("KPay (gateway)", "KPay（閘道）", "KPay（网关）"),
    kpayTransactionFinishTime: build("Transaction finish time", "交易完成時間", "交易完成时间"),
    kpayOrderNo: build("KPay order no.", "KPay 訂單編號", "KPay 订单编号"),
    kpayTransactionNo: build("Transaction no.", "交易編號", "交易编号"),
    kpayManagedOrderNo: build("Managed order no.", "托管訂單編號", "托管订单编号"),
    kpayManagedMerchantOrderNo: build("Managed merchant order no.", "商戶託管訂單編號", "商户托管订单编号"),
    kpayRefund: build("Refund", "退款", "退款"),
    kpayRefundAmount: build("Refund amount", "退款金額", "退款金额"),
    kpayRefundSubmit: build("Submit refund", "提交退款", "提交退款"),
    kpayRefundSuccess: build("Refund processed", "退款已處理", "退款已处理"),
    kpayRefundConfirmTitle: build("Confirm KPay refund", "確認 KPay 退款", "确认 KPay 退款"),
    kpayRefundConfirmMessage: build(
      "You are about to submit a refund for the following amount. Continue?",
      "你即將提交以下金額的退款，是否繼續？",
      "你即将提交以下金额的退款，是否继续？"
    ),
  },
  paymentSettings: {
    stripeSettings: build("Stripe Settings", "Stripe 設定", "Stripe 设置"),
    paypalSettings: build("PayPal Settings", "PayPal 設定", "PayPal 设置"),
    kpaySettings: build("Kpay Settings", "Kpay 設定", "Kpay 设置"),
    paymeSettings: build("Payme Settings", "Payme 設定", "Payme 设置"),
    liveSettings: build("Live Settings", "正式環境設定", "正式环境设置"),
    sandboxSettings: build("Sandbox Settings", "測試環境設定", "测试环境设置"),
    stripeClientId: build("Stripe Client ID (Production)", "Stripe 客戶端 ID（Live）", "Stripe 客户端 ID（Live）"),
    stripeSecretKey: build("Stripe Secret Key (Production)", "Stripe 密鑰（Live）", "Stripe 密钥（Live）"),
    stripeWebhookSecret: build(
      "Stripe Webhook Secret (Production)",
      "Stripe Webhook 密鑰（Live）",
      "Stripe Webhook 密钥（Live）"
    ),
    stripeTestClientId: build("Stripe Test Client ID", "Stripe 測試客戶端 ID", "Stripe 测试客户端 ID"),
    stripeTestSecretKey: build("Stripe Test Secret Key", "Stripe 測試密鑰", "Stripe 测试密钥"),
    stripeTestWebhookSecret: build("Stripe Test Webhook Secret", "Stripe 測試 Webhook 密鑰", "Stripe 测试 Webhook 密钥"),
    paypalClientId: build("PayPal Client ID (Live)", "PayPal 客戶端 ID（Live）", "PayPal 客户端 ID（Live）"),
    paypalClientSecret: build("PayPal Client Secret (Live)", "PayPal 客戶端密鑰（Live）", "PayPal 客户端密钥（Live）"),
    paypalWebhookSecret: build("PayPal Webhook ID (Live)", "PayPal Webhook ID（Live）", "PayPal Webhook ID（Live）"),
    paypalTestClientId: build("PayPal Test Client ID", "PayPal 測試客戶端 ID", "PayPal 测试客户端 ID"),
    paypalTestClientSecret: build("PayPal Test Client Secret", "PayPal 測試客戶端密鑰", "PayPal 测试客户端密钥"),
    paypalTestWebhookSecret: build("PayPal Test Webhook ID", "PayPal 測試 Webhook ID", "PayPal 测试 Webhook ID"),

    kpayClientId: build("Kpay Client ID (Live)", "Kpay 客戶端 ID（Live）", "Kpay 客户端 ID（Live）"),
    kpayClientSecret: build("Kpay Client Secret (Live)", "Kpay 客戶端密鑰（Live）", "Kpay 客户端密钥（Live）"),
    kpayWebhookSecret: build("Kpay Webhook ID (Live)", "Kpay Webhook ID（Live）", "Kpay Webhook ID（Live）"),
    kpayTestClientId: build("Kpay Test Client ID", "Kpay 測試客戶端 ID", "Kpay 测试客户端 ID"),
    kpayTestClientSecret: build("Kpay Test Client Secret", "Kpay 測試客戶端密鑰", "Kpay 测试客户端密钥"),
    kpayTestWebhookSecret: build("Kpay Test Webhook ID", "Kpay 測試 Webhook ID", "Kpay 测试 Webhook ID"),

    paymeClientId: build("Payme Client ID (Live)", "Payme 客戶端 ID（Live）", "Payme 客户端 ID（Live）"),
    paymeClientSecret: build("Payme Client Secret (Live)", "Payme 客戶端密鑰（Live）", "Payme 客户端密钥（Live）"),
    paymeWebhookSecret: build("Payme Webhook ID (Live)", "Payme Webhook ID（Live）", "Payme Webhook ID（Live）"),
    paymeTestClientId: build("Payme Test Client ID", "Payme 測試客戶端 ID", "Payme 测试客户端 ID"),
    paymeTestClientSecret: build("Payme Test Client Secret", "Payme 測試客戶端密鑰", "Payme 测试客户端密钥"),
    paymeTestWebhookSecret: build("Payme Test Webhook ID", "Payme 測試 Webhook ID", "Payme 测试 Webhook ID"),

    saving: build("Saving...", "儲存中...", "保存中..."),
    settingsSavedSuccessfully: build("Settings saved successfully", "設定已成功儲存", "设置已成功保存"),
    errorSavingSettings: build("Error saving settings", "儲存設定時發生錯誤", "保存设置时发生错误"),
  },
  date: {
    today: build("Today", "今天", "今天"),
    last7Days: build("Last 7 Days", "過去7天", "过去7天"),
    last30Days: build("Last 30 Days", "過去30天", "过去30天"),
    lastQuater: build("Last Quater", "上一季", "上一季"),
    last365Days: build("Last 365 Days", "過去365天", "过去365天"),
    thisWeek: build("This Week", "本星期", "本星期"),
    thisMonth: build("This Month", "本月", "本月"),
    thisQuater: build("This Quater"),
    thisYear: build("This Year"),
    fromDate: build("From Date", "日期開始", "日期开始"),
    toDate: build("To Date", "日期結束", "日期结束"),
    customDateRange: build("Custom Date Range"),
    customDate: build("Custom Date", "自訂日期", "自訂日期"),
    ytd: build("YTD", "本年度", "本年度"),
  },
  mailTemplate: {
    templateType: build("Template Type"),
    mailTemplate: build("Mail Template", "郵件範本", "邮件范本"),
    mailTempalteTest: build("Mail Template Test", "郵件範本測試", "邮件范本测试"),
    mailTemplateEditor: build("Mail Template Editor", "郵件範本編輯", "邮件范本编辑"),
    subject: build("Mail Subject", "郵件主題", "邮件主题"),
    body: build("Mail Body", "郵件內容", "邮件内容"),
    type: build("Mail Type", "郵件類型", "邮件类型"),
    add: build("Add Mail Template", "新增電郵模板", "新增电邮模板"),
    cartReminder: build("Cart Reminder", "購物車提醒", "购物车提醒"),
    orderCreated: build("Order Created", "訂單已建立", "订单已创建"),
    orderConfirmed: build("Order Confirmed", "訂單已確認", "订单已确认"),
    orderCancelled: build("Order Cancelled", "訂單已取消", "订单已取消"),
    orderAutoCancelled: build("Order Auto Cancelled", "訂單自動取消", "订单自动取消"),
    orderShipped: build("Order Shipped", "訂單已出貨", "订单已发货"),
    orderDelivered: build("Order Delivered", "訂單已送達", "订单已送达"),
    deliveryLogisticDelivered: build("Delivery Logistic Delivered", "配送已送達", "配送已送达"),
    pickupCompleted: build("Pickup Completed", "已自取", "已自取"),
    deliveryPreparing: build("Delivery Preparing", "執緊貨", "备货中"),
    deliveryCanPickup: build("Ready for Pickup", "可自取", "可自取"),
    paymentRefunded: build("Payment Refunded", "付款已退還", "付款已退还"),
    passwordReset: build("Password Reset", "重設密碼", "重设密码"),
    emailVerification: build("Email Verification", "電郵驗證", "电邮验证"),
    orderConfirmedAdmin: build("Order Confirmed Admin", "訂單已確認 (管理員)", "订单已确认 (管理员)"),
    orderCancelledAdmin: build("Order Cancelled Admin", "訂單已取消 (管理員)", "订单已取消 (管理员)"),
    instockNotification: build("In-Stock Notification Admin", "到貨通知", "到货通知"),
    formSubmission: build("Form Submission", "表單提交", "表单提交"),
    toList: build("To", "收件人", "收件人"),
    ccList: build("CC", "副本", "副本"),
    bccList: build("BCC", "密件副本", "密件副本"),
    noOrdersForTest: build(
      "No orders available for testing. Create an order first.",
      "沒有可用的訂單進行測試。請先建立訂單。",
      "没有可用的订单进行测试。请先创建订单。"
    ),
    selectTrackingId: build("Select Tracking ID", "選擇追蹤編號", "选择追踪编号"),
    noDeliveriesForTest: build(
      "No deliveries available for testing. Create a delivery schedule first.",
      "沒有可用的配送進行測試。請先建立配送排程。",
      "没有可用的配送进行测试。请先创建配送排程。"
    ),
  },
  recycle: {
    recycle: build("Recycle", "回收", "回收"),
    recycles: build("Recycles", "回收", "回收"),
    totalPending: build("Total Pending", "总待处理", "總待處理"),
    totalRecycle: build("Total Recycles", "總回收量", "总回收量"),
  },
  receiptTemplate: {
    templateType: build("Template Type"),
    receiptMediaUrl: build("Receipt Media Url"),
    receiptTemplate: build("Receipt Template", "收據模板", "收据模板"),
    receiptTemplateEditor: build("Receipt Template Editor", "收據模板編輯", "收据模板编辑"),
    subject: build("Mail Subject", "郵件主題", "邮件主题"),
    body: build("Mail Body", "郵件內容", "邮件内容"),
    add: build("Add Receipt Template", "新增收據模板", "添加收据模板"),
  },
  checkout: {
    pickup: build("Store Pick Up", "門市自取", "門市自取"),
    delivery: build("Delivery", "送貨", "送货"),
    sfPickup: build("SF Pickup", "順豐自取服務", "順豐自取服務"),
  },
  pos: {
    customerSpendingInfo: build("Customer Spending Info", "客戶消費資訊", "客戶消費資訊"),
    home: build("Home", "首頁", "首頁"),
    posSytem: build("Retail", "零售店舖", "零售店舖"),
    addStore: build("Add Retail Store", "新增零售店舖", "新增零售店舖"),
    addRetailShop: build("Add Retail Shop", "新增零售店舖", "新增零售店舖"),
    editRetailShop: build("Edit Retail Shop", "管理零售用戶", "更改零售店舖"),
    deleteRetailShop: build("Delete Retail Shop", "刪除零售店舖", "刪除零售店舖"),
    createRetailShop: build("Create Retail Shop", "新增零售店舖", "新增零售店舖"),
    customerInfo: build("Customer Info", "客戶資料", "客戶資料"),
    numberInfo: build("Number Info", "數量資料", "數量資料"),
    eyesInfo: build("Eyes Info", "眼睛資料", "眼睛資料"),
    bodySizeInfo: build("Body Size Info", "身體尺寸資訊", "体型信息"),
    posSettings: build("POS Settings", "POS 設定", "POS 设置"),
    print: build("Print", "列印", "列印"),
    select: build("Select", "選擇", "選擇"),
    discard: build("Discard", "放棄", "放棄"),
    shortDescription: build("Short Description", "簡短說明", "簡短說明"),
    productDescription: build("Product Description", "產品說明", "產品說明"),
    holdCart: build("Hold Cart", "暫存購物車", "暫存購物車"),
    proceed: build("Proceed", "繼續", "繼續"),
    pay: build("Pay", "付款", "付款"),
    subTotal: build("Sub Total", "小計", "小計"),
    payableAmount: build("Payable Amount", "應付金額", "應付金額"),
    userChange: build("User Change", "找零", "找零"),
    bill: build("Bill", "單據", "單據"),
    totalAmount: build("Total Amount", "總金額", "總金額"),
    paymentStatus: build("Payment Status", "付款狀態", "付款狀態"),
    orderInfo: build("Order Info", "訂單資料", "訂單資料"),
    memberInfo: build("Member Info", "會員資料", "會員資料"),
    guestCheckout: build("Guest Checkout", "訪客結帳", "訪客結帳"),
    customer: build("Customer", "客戶", "客戶"),
    clientInfo: build("Client Info", "客戶資料", "客戶資料"),
    orders: build("Orders", "訂單", "訂單"),
    items: build("Items", "產品", "產品"),
    posStatus: build("POS Status", "POS 狀態", "POS 状态"),
    chooseUser: build("Choose User", "選擇用戶", "选择用户"),
    type: build("Retail User Role", "零售用戶角色", "零售用户角色"),
    typeRetailManager: build("Retail Manager", "零售經理", "零售经理"),
    typeRetailUser: build("Retail User", "零售用戶", "零售用户"),
    noUsersAreSelected: build("No Users are selected", "沒任選擇任何用戶", "没任选择任何用户"),
    visa: build("Visa", "Visa", "Visa"),
    masterCard: build("Master Card", "Master Card", "Master Card"),
    ae: build("American Express", "American Express", "American Express"),
    alipay: build("Alipay", "Alipay", "Alipay"),
    wechat: build("WechatPay", "WechatPay", "WechatPay"),
    paypal: build("PayPal", "PayPal", "PayPal"),
    payme: build("Payme", "Payme", "Payme"),
    paymentOptions: build("Payment Options", "付款選項", "付款選項"),
    cash: build("Cash", "現金", "現金"),
    fps: build("FPS", "FPS", "FPS"),
    octopus: build("Octopus", "Octopus", "Octopus"),
    unionPay: build("Union Pay", "Union Pay", "Union Pay"),
    applePay: build("Apple Pay", "Apple Pay", "Apple Pay"),
    samsungPay: build("Samsung Pay", "Samsung Pay", "Samsung Pay"),
    googlePay: build("Google Pay", "Google Pay", "Google Pay"),
    hcv: build("Health Care Voucher", "醫療券", "医疗券"),
    addPrintUser: build("Add Print User", "新增列印用戶", "新增列印用户"),
    printUserToken: build("Print User Token", "列印用戶詞符", "列印用户词符"),
    copy: build("Copy", "複製", "複製"),
    copied: build("Copied", "已複製", "已複製"),
    code: build("Code", "代碼", "代碼"),
    allowCouponWithPriceOverride: build(
      "Allow Coupon With Price Override",
      "允許在更改價格時使用優惠券",
      "允许在更改价格时使用优惠券"
    ),
    listOfAllowedIPs: build("List of Allowed IPs", "允許的IP列表", "允許的IP列表"),
    addIp: build("Add", "新增", "新增"),
    ipInputPlaceholder: build(
      "e.g., 192.168.1.1 or ::ffff:127.0.0.1",
      "例如：192.168.1.1 或 ::ffff:127.0.0.1",
      "例如：192.168.1.1 或 ::ffff:127.0.0.1"
    ),
    noIpAddressesAdded: build("No IP addresses added", "尚未新增IP地址", "尚未新增IP地址"),
    cloudPrintersTitle: build("Cloud receipt printers (XPrinter)", "雲端收據打印機（芯烨）", "云端收据打印机（芯烨）"),
    cloudPrinterSn: build("Serial number (SN)", "序號（SN）", "序号（SN）"),
    cloudPrinterName: build("Printer name", "打印機名稱", "打印机名称"),
    addCloudPrinter: build("Add cloud printer", "新增雲端打印機", "新增云端打印机"),
    cloudPrintersSaveSuccess: build("Cloud printer list saved.", "已儲存雲端打印機列表。", "已保存云端打印机列表。"),
    cloudPrinterSnRequired: build(
      "Each cloud printer must have a serial number (SN).",
      "每台雲端打印機必須填寫序號（SN）。",
      "每台云端打印机必须填写序号（SN）。"
    ),
  },
  formLabels: {
    enterName: build("Enter Name", "輸入名稱", "輸入名稱"),
    enterAddress: build("Enter Address", "輸入地址", "輸入地址"),
    enterTel: build("Enter Phone Number", "輸入電話號碼", "輸入電話號碼"),
    enterNote: build("Enter Note", "輸入備註", "輸入備註"),
    pdfInvoiceCode: build("PDF Invoice Code", "PDF收據編碼", "PDF收據編碼"),
    selectDateFrom: build("Date From", "選擇開始日期", "选择开始日期"),
    selectDateTo: build("Date To", "選擇結束日期", "选择结束日期"),
  },
  posMenuItems: {
    newOrder: build("New Order", "新增訂單", "新增訂單"),
    customers: build("Customers", "客戶", "客戶"),
    orderList: build("Order List", "訂單列表", "訂單列表"),
    history: build("History", "歷史", "歷史"),
    products: build("Products", "產品", "產品"),
    warehouse: build("Warehouse", "倉庫", "倉庫"),
    supplier: build("Supplier"),
    deliveryPoint: build("Delivery Point"),
    orderDetails: build("Order details"),
    supplierInvoiceNumber: build("Supplier invoice number"),
    deliveryDate: build("Delivery Date", "送貨日期", "送货日期"),
    scanProduct: build("Scan Product", "掃描產品", "掃描產品"),
    searchProducts: build("Search products", "搜尋產品", "搜尋產品"),
  },
  posProducts: {
    cartClearSuccessfully: build("Successfully Cleared Cart", "已成功清除購物車", "已成功清除購物車"),
    addToCartSuccessfully: build("Successfully Added Item To Cart", "已成功將商品添加到購物車", "已成功將商品添加到購物車"),
    removeFromCartSuccessfully: build(
      "Successfully Removed Item From Cart",
      "已成功從購物車中刪除商品",
      "已成功從購物車中刪除商品"
    ),
  },
  warehouseTransfer: {
    title: build("Warehouse transfers", "倉庫調撥", "仓库调拨"),
    transferNumber: build("Transfer no.", "調撥編號", "调拨编号"),
    sectionDetails: build("Transfer details", "調撥資料", "调拨资料"),
    fromWarehouse: build("From warehouse", "來貨倉", "来货仓"),
    fromStore: build("From store", "來源分店", "来源分店"),
    toStore: build("To store", "目的地分店", "目的地分店"),
    toWarehouse: build("To warehouse", "收貨倉", "收货仓"),
    lineItems: build("Line items", "明細", "明细"),
    quantity: build("Quantity", "數量", "数量"),
    shippedQty: build("Shipped", "已出貨", "已出货"),
    receivedQty: build("Received", "已收貨", "已收货"),
    printedAt: build("Printed at", "列印時間", "列印时间"),
    downloadPdf: build("Download PDF", "下載PDF", "下载PDF"),
    printAndDownloadPdf: build("Print & download PDF", "列印並下載PDF", "列印并下载PDF"),
    printWorkflowSuccess: build("Printed — transfer is now picking.", "已列印 — 調撥單現正執貨。", "已列印 — 调拨单现正拣货。"),
    errPrintFailed: build(
      "Could not print (transfer must be submitted first).",
      "無法列印（調撥單須為已提交狀態）。",
      "无法列印（调拨单须为已提交状态）。"
    ),
    markOnDeliveryAction: build("Dispatch (on delivery)", "發貨 / 運送中", "发货 / 运送中"),
    markOnDeliverySuccess: build("Marked as on delivery.", "已標記為運送中。", "已标记为运送中。"),
    errMarkOnDeliveryFailed: build(
      "Could not mark on delivery (transfer must be picking).",
      "無法標記運送（調撥單須為執貨中）。",
      "无法标记运送（调拨单须为拣货中）。"
    ),
    save: build("Save changes", "儲存變更", "保存变更"),
    saveSuccess: build("Transfer saved successfully.", "調撥單已成功儲存。", "调拨单已成功保存。"),
    status: build("Status", "狀態", "状态"),
    searchTransferNo: build("Search transfer no.", "搜尋調撥編號", "搜寻调拨编号"),
    filterStatus: build("Status filter", "狀態篩選", "状态筛选"),
    allStatuses: build("All statuses", "所有狀態", "所有状态"),
    notEditableHint: build(
      "This transfer can no longer be edited after picking has started.",
      "執貨開始後無法再編輯此調撥單。",
      "执货开始后无法再编辑此调拨单。"
    ),
    statusDraft: build("Draft", "草稿", "草稿"),
    statusSubmitted: build("Submitted", "已提交", "已提交"),
    statusPicking: build("Picking", "執貨中", "拣货中"),
    statusOnDelivery: build("On delivery", "派送中", "派送中"),
    statusStockInCompleted: build("Stock-in completed", "入倉完成", "入仓完成"),
    errTransferNotEditable: build("This transfer is not editable.", "此調撥單不可編輯。", "此调拨单不可编辑。"),
    errTransferNoteNotFound: build("Transfer not found.", "找不到調撥單。", "找不到调拨单。"),
    errProductNotFound: build("A product on this transfer was not found.", "調撥單中有產品不存在。", "调拨单中有产品不存在。"),
  },
  audit: {
    actionType: build("Action", "動作", "动作"),
    modifiedBy: build("By", "修改人", "修改人"),
    modify: build("Modify", "修改", "修改"),
    delete: build("Delete", "刪除", "刪除"),
  },
  dev: {
    dev: build("Developer", "開發者", "开发者"),
    apiKeys: build("API Keys", "API 金鑰", "API 金钥"),
    token: build("API Token", "API 金鑰", "API 金鑰"),
  },
  settingItem: {
    active: build("Active", "生效", "生效"),
    inactive: build("Inactive", "停用", "停用"),
  },
  errors: {
    amtGreaterThanZero: build("Amount must be greater than zero", "金額必須大於零", "金额必须大于零"),
    contactAdmin: build(
      "Something went Wrong. Please contact Admin if unsure how to proceed",
      "出了點問題。如果不確定如何繼續，請聯絡管理員",
      "出了点问题。如果不确定如何继续，请联系管理员"
    ),
    insufficientBalance: build("Insufficient Balance", "餘額不足", "余额不足"),
    reasonRequired: build("Reason Is Required", "需要原因", "必填项"),
    selectTransactionType: build("Please select transaction type", "請選擇交易類型", "请选择交易类型"),
  },
};

export type MessageType = typeof messages;

export default messages;
